<template>
  <div id="productModule" class="productModuleContainer" style="position: relative">
    <div class="fake-scrollbar mobile">
      <div class="fake-thumb"></div>
    </div>
    <div class="product-box">
      <div class="product-table scroll-fade-up" :class="{ newTypeTable: newTypeTable, etfLayoutTable: tabIndex == 4 ,stockLayoutTable:tabIndex == 3}">
        <div class="product-table-th etf-layout" v-if="tabIndex == 4">
          <div class="product-table-td body-16_regular md-footnote-medium_12">交易产品</div>
          <div class="product-table-td body-16_regular md-footnote-medium_12">卖出价</div>
          <div class="product-table-td body-16_regular md-footnote-medium_12">买入价</div>
          <div class="product-table-td body-16_regular md-footnote-medium_12">投资焦点</div>
          <div class="product-table-td body-16_regular md-footnote-medium_12">ETF 规模（亿美元）</div>
          <div class="product-table-td body-16_regular md-footnote-medium_12">
            {{ returnTextMap[currentReturnKey] }}

            <div class="dropdown-container cursor-pointer" @mouseenter="!isMoible && (showReturnDropdown = true)"
              @mouseleave="!isMoible && (showReturnDropdown = false)"
              @click.stop="showReturnDropdown = !showReturnDropdown">
              <span class="iconfont icon-a-down"></span>
              <div class="etf-dropdown-menu" v-show="showReturnDropdown">
                <div class="etf-dropdown-menu-inner box-border">
                  <div class="etf-dropdown-item" :class="{ active: currentReturnKey === 'total_return' }"
                    @click.stop="selectReturn('total_return')">历史总收益率</div>
                  <div class="etf-dropdown-item" :class="{ active: currentReturnKey === '10y' }"
                    @click.stop="selectReturn('10y')">过去 10 年</div>
                  <div class="etf-dropdown-item" :class="{ active: currentReturnKey === '5y' }"
                    @click.stop="selectReturn('5y')">过去 5 年</div>
                  <div class="etf-dropdown-item" :class="{ active: currentReturnKey === '3y' }"
                    @click.stop="selectReturn('3y')">过去 3 年</div>
                  <div class="etf-dropdown-item" :class="{ active: currentReturnKey === '1y' }"
                    @click.stop="selectReturn('1y')">过去 1 年</div>
                </div>
              </div>
            </div>
          </div>

          <div class="product-table-td body-16_regular md-footnote-medium_12">
            {{ betaTextMap[currentBetaKey] }}

            <span class="iconfont icon-a-tipsicon info-icon cursor-pointer" @mouseenter="showBetaTooltip = true"
              @mouseleave="showBetaTooltip = false">
              <div class="tooltip-box box-border" v-show="showBetaTooltip">
                β 值衡量 ETF 相对市场的波动敏感度，基于历史数据计算，不代表未来表现。
              </div>
            </span>

            <div class="dropdown-container cursor-pointer" @mouseenter="!isMoible && (showBetaDropdown = true)"
              @mouseleave="!isMoible && (showBetaDropdown = false)" @click.stop="showBetaDropdown = !showBetaDropdown">
              <span class="iconfont icon-a-down"></span>
              <div class="etf-dropdown-menu" v-show="showBetaDropdown">
                <div class="etf-dropdown-menu-inner box-border">
                  <div class="etf-dropdown-item" :class="{ active: currentBetaKey === 'beta_5y' }"
                    @click.stop="selectBeta('beta_5y')">过去 5 年 β</div>
                  <div class="etf-dropdown-item" :class="{ active: currentBetaKey === 'beta_3y' }"
                    @click.stop="selectBeta('beta_3y')">过去 3 年 β</div>
                  <div class="etf-dropdown-item" :class="{ active: currentBetaKey === 'beta_1y' }"
                    @click.stop="selectBeta('beta_1y')">过去 1 年 β</div>
                </div>
              </div>
            </div>
          </div>
        </div>
         <div class="product-table-th stock-layout" v-else-if="tabIndex == 3">
      <div class="product-table-td body-16_regular md-footnote-medium_12">交易产品</div>
      <div class="product-table-td body-16_regular md-footnote-medium_12">卖出价</div>
      <div class="product-table-td body-16_regular md-footnote-medium_12">买入价</div>
      <div class="product-table-td body-16_regular md-footnote-medium_12 stock-sort-th cursor-pointer" @click="selectStockSort('monthData')">
        <span>近1个月涨跌幅</span>
        <span class="iconfont icon-a-down" :class="{rotate180: currentStockSortKey === 'monthData' && currentStockSortOrder === 'asc'}"></span>
      </div>
      <div class="product-table-td body-16_regular md-footnote-medium_12 stock-sort-th cursor-pointer" @click="selectStockSort('yearData')">
        <span>近1年涨跌幅</span>
        <span class="iconfont icon-a-down" :class="{rotate180: currentStockSortKey === 'yearData' && currentStockSortOrder === 'asc'}"></span>
      </div>
      <div class="product-table-td body-16_regular md-footnote-medium_12">品类</div>
    </div>
        <div class="product-table-th" v-else>
          <div class="product-table-td body-16_regular md-footnote-medium_12">
            交易产品
          </div>
          <div class="product-table-td body-16_regular md-footnote-medium_12">
            卖出价
          </div>
          <div class="product-table-td body-16_regular md-footnote-medium_12">
            买入价
          </div>
          <div class="product-table-td body-16_regular md-footnote-medium_12">
            点差
          </div>
          <div class="product-table-td body-16_regular md-footnote-medium_12">
            杠杆
          </div>
          <div class="product-table-td body-16_regular md-footnote-medium_12">
            流动性深度
          </div>
        </div>
        <div class="product-table-row" v-for="(item, index) in isMoible
          ? showData.slice(
            (targetNavigationIndex - 1) * 6,
            (targetNavigationIndex - 1) * 6 + 6
          )
          : showData" :key="index" :class="{ newTypeTableChooseRow: newTypeTable && index == innerTickIndex }">
          <div class="product-table-tr etf-layout" v-if="tabIndex == 4" v-show="(index > 7 && showMore) || index <= 7">
            <div class="product-table-td">
              <div class="subtitle-18_medium md-body-14_medium">{{ item.symbolZh || item.symbol }}</div>
              <div class="etf-symbol-text body-14_regular">{{ item.symbol }}</div>
            </div>
            <div class="product-table-td body-16_medium md-body-14_medium" :class="[item.tick[0]?.bidClassName]">
              {{ item.tick[0]?.bid_price }}
            </div>
            <div class="product-table-td body-16_medium md-body-14_medium" :class="[item.tick[0]?.askClassName]">
              {{ item.tick[0]?.ask_price }}
            </div>
            <div class="product-table-td body-16_medium md-body-14_medium">{{ item.focus }}</div>
            <div class="product-table-td body-16_medium md-body-14_medium">{{ item.fundSize }}</div>
            <div class="product-table-td body-16_medium md-body-14_medium"
              :class="{ 'product-green': item.returns[currentReturnKey]?.includes('+'), 'product-red': item.returns[currentReturnKey]?.includes('-') }">
              {{ item.returns[currentReturnKey] }}
            </div>
            <div class="product-table-td body-16_medium md-body-14_medium">
              <span v-if="item.symbol === 'SMH'" class="demo-outline">{{ item.betas[currentBetaKey] }}</span>
              <span v-else>{{ item.betas[currentBetaKey] }}</span>
            </div>
          </div>
               <div class="product-table-tr stock-layout" v-else-if="tabIndex == 3" v-show="(index>7 && showMore) || index<=7">
        <div class="product-table-td">
          <div class="flex items-center productPageTable stock-product-cell">
            <img :src="getImage(item.symbol)" alt="">
            <div>
              <div class="subtitle-18_medium md-body-14_medium">{{ stockDisplayName(item) }}</div>
              <div class="body-14_regular secondTitle">{{ item.symbol }} </div>
            </div>
          </div>
        </div>
        <div class="product-table-td body-16_medium md-body-14_medium" :class="[item.tick[0]?.bidClassName]">
          {{ item.tick[0]?.bid_price }}
        </div>
        <div class="product-table-td body-16_medium md-body-14_medium" :class="[item.tick[0]?.askClassName]">
          {{ item.tick[0]?.ask_price }}
        </div>
        <div class="product-table-td body-16_medium md-body-14_medium" :class="stockPercentClass(item.stockData?.perData?.monthData)">
          {{ item.stockData?.perData?.monthData || '-' }}
        </div>
        <div class="product-table-td body-16_medium md-body-14_medium" :class="stockPercentClass(item.stockData?.perData?.yearData)">
          {{ item.stockData?.perData?.yearData || '-' }}
        </div>
        <div class="product-table-td body-16_regular md-body-14_regular">
          {{ stockCategoryText(item) }}
        </div>
      </div>
          <div class="product-table-tr" v-else v-show="(index > 7 && showMore) || index <= 7 || tabIndex < 3"
            @click="showFormPopup(index)">
            <div class="product-table-td subtitle-18_medium md-body-14_medium">
              <template v-if="newTypeTable">
                {{ item.symbolZh || item.symbol }}
              </template>
              <template v-else>
                <div class="flex items-center productPageTable">
                  <img :src='getImage(item.symbol)' alt="">
                  <div>
                    <div>{{ item.symbolZh }}</div>
                    <div class="body-14_regular secondTitle">{{ item.symbol }}</div>
                  </div>
                </div>
              </template>
            </div>
            <div class="product-table-td body-16_medium md-body-14_medium"
              :style="{ opacity: newTypeTable && !isMoible && index == innerTickIndex ? 0 : 1 }"
              :class="[item.tick[0].bidClassName]">
              {{ item.tick[0].bid_price }}
            </div>

            <div class="product-table-td body-16_medium md-body-14_medium"
              :style="{ opacity: newTypeTable && !isMoible && index == innerTickIndex ? 0 : 1 }"
              :class="[item.tick[0].askClassName]">
              {{ item.tick[0].ask_price }}
            </div>
            <div class="product-table-td body-16_medium md-body-14_medium"
              :style="{ opacity: newTypeTable && !isMoible && index == innerTickIndex ? 0 : 1 }">
              {{ item.tick[0].spread }}
            </div>
            <div class="product-table-td body-16_medium md-body-14_medium" v-html="item.rule"
              :style="{ opacity: newTypeTable && !isMoible && index == innerTickIndex ? 0 : 1 }">
            </div>

            <div class="
                product-table-td
                body-16_medium
                md-footnote-medium_12
                cursor-pointer
              ">
              查看
              <span class="iconfont icon-a-down rotate90"></span>
            </div>
          </div>
          <div class="product-table-row newTypeInnerTable" v-if="newTypeTable && !isMoible && innerTickIndex == index">
            <div class="product-innertable body-16_medium">
              <div class="product-innertable-th md-footnote-medium_12">
                <div class="product-innertable-td">
                  layer
                  <span class="iconfont icon-a-tipsicon cursor-pointer" data-popover="p1"></span>

                </div>
                <div class="product-innertable-td">Bid</div>
                <div class="product-innertable-td" v-if="tabIndex != 3 && tabIndex != 4">
                  Bid Volume
                </div>
                <div class="product-innertable-td">Ask</div>
                <div class="product-innertable-td" v-if="tabIndex != 3 && tabIndex != 4">
                  Ask Volume
                </div>
                <div class="product-innertable-td">Spread</div>
              </div>
              <div class="product-innertable-tbody">
                <div class="product-innertable-tr md-body-14_medium" v-for="(el, i) in innerTickList">
                  <div class="product-innertable-td">{{ i + 1 }}</div>
                  <div class="product-innertable-td" :class="[el.bidClassName]">
                    {{ el.bid_price }}
                  </div>
                  <div class="product-innertable-td" v-if="tabIndex != 3 && tabIndex != 4">
                    {{ el.bid_size ? el.bid_size : "-" }}
                  </div>
                  <div class="product-innertable-td" :class="[el.askClassName]">
                    {{ el.ask_price }}
                  </div>
                  <div class="product-innertable-td" v-if="tabIndex != 3 && tabIndex != 4">
                    {{ el.ask_size ? el.ask_size : "-" }}
                  </div>
                  <div class="product-innertable-td">{{ el.spread }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="iBtn secondary-default_large" v-if="tabIndex == 3 || tabIndex == 4" @click="showMore = !showMore">
        查看所有产品
        <span class="iconfont icon-a-down" :class="{ rotate180: showMore }"></span>
      </div>
      <div class="formPopup box-border" :class="{ showFormPopup: popupControl }"
        v-if="(newTypeTable && isMoible) || !newTypeTable">
        <span class="formPopupClose" @click="closePopup">
          <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
            <g clip-path="url(#clip0_4123_9841)">
              <path
                d="M23.2893 7.29284C23.6798 6.90235 24.3128 6.90242 24.7034 7.29284C25.0939 7.68336 25.0939 8.31637 24.7034 8.7069L17.4104 15.9999L24.7034 23.2928L24.7724 23.369C25.0925 23.7617 25.0694 24.3408 24.7034 24.7069C24.3374 25.0727 23.7582 25.0959 23.3655 24.7759L23.2893 24.7069L15.9964 17.4139L8.70341 24.7069C8.31287 25.0972 7.67983 25.0973 7.28935 24.7069C6.89898 24.3164 6.899 23.6833 7.28935 23.2928L14.5823 15.9999L7.28935 8.7069C6.89898 8.31641 6.899 7.68334 7.28935 7.29284C7.67984 6.90235 8.31288 6.90242 8.70341 7.29284L15.9964 14.5858L23.2893 7.29284Z"
                fill="black" fill-opacity="0.48" />
            </g>
            <defs>
              <clipPath id="clip0_4123_9841">
                <rect width="32" height="32" fill="white" />
              </clipPath>
            </defs>
          </svg>
        </span>
        <h2 class="title-32_bold md-title-24_medium">实时报价深度</h2>
        <h3 class="body-16_regular md-footnote-regular_12">
          EBC 直连 25+ 顶级流动性，基于专业级 HUB 基础设施与智能订单路由（SOR）执行引擎，提供多档报价深度，实时透明呈现市场流动性层级。
        </h3>
        <div class="innerTableContainer" style="position: relative">
          <div class="fake-scrollbar mobile">
            <div class="fake-thumb"></div>
          </div>
          <div class="product-table" :class="{ 'grow-product-table': tabIndex == 3 || tabIndex == 4 }">
            <div class="product-table-row">
              <div class="product-innertable body-16_medium">
                <div class="product-innertable-th md-footnote-medium_12">
                  <div class="product-innertable-td">
                    layer
                    <span class="iconfont icon-a-tipsicon cursor-pointer" data-popover="p1"></span>
                  </div>
                  <div class="product-innertable-td">Bid</div>
                  <div class="product-innertable-td" v-if="tabIndex != 3 && tabIndex != 4">
                    Bid Volume
                  </div>
                  <div class="product-innertable-td">Ask</div>
                  <div class="product-innertable-td" v-if="tabIndex != 3 && tabIndex != 4">
                    Ask Volume
                  </div>
                  <div class="product-innertable-td">Spread</div>
                </div>
                <div class="product-innertable-tbody">
                  <div class="product-innertable-tr md-body-14_medium" v-for="(el, i) in innerTickList" :key="i">
                    <div class="product-innertable-td">{{ i + 1 }}</div>
                    <div class="product-innertable-td" :class="[el.bidClassName]">
                      {{ el.bid_price }}
                    </div>
                    <div class="product-innertable-td" v-if="tabIndex != 3 && tabIndex != 4">
                      {{ el.bid_size ? el.bid_size : "-" }}
                    </div>
                    <div class="product-innertable-td" :class="[el.askClassName]">
                      {{ el.ask_price }}
                    </div>
                    <div class="product-innertable-td" v-if="tabIndex != 3 && tabIndex != 4">
                      {{ el.ask_size ? el.ask_size : "-" }}
                    </div>
                    <div class="product-innertable-td">{{ el.spread }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="mobile">
      <div class="pageNavigation flex justify-center items-center">
        <span class="iconfont icon-a-down" :class="{ notAllow: targetNavigationIndex == 1 }"
          style="transform: rotate(90deg)" @click="targetNavigationIndex = targetNavigationIndex - 1"></span>
        <div v-for="item in visiblePages" class="md-footnote-regular_12"
          :class="targetNavigationIndex === item ? 'active' : ''" @click="setTargetNavigationIndex(item)">
          {{ (item === '+1' || item === '-1') ? '...' : item }}
        </div>
        <span class="iconfont icon-a-down" :class="{ notAllow: targetNavigationIndex == pageNavigationNumber }"
          style="transform: rotate(-90deg)" @click="targetNavigationIndex = targetNavigationIndex + 1"></span>
      </div>
    </div>
  </div>
</template>

<script>
import md5 from "js-md5";
const myEvent = new CustomEvent("mountedSuccess", {
  detail: true,
  bubbles: false,
  cancelable: true,
});
const stockCategoryAllTextMap = {
  "zh-cn": "全部品类",
  zh: "全部品類",
  jp: "全カテゴリ",
  kr: "전체 카테고리",
  th: "ทุกหมวดหมู่",
  id: "Semua kategori",
  vi: "Tất cả danh mục",
  pt: "Todas as categorias",
  es: "Todas las categorías",
  ru: "Все категории",
  hi: "सभी श्रेणियां",
  ar: "كل الفئات",
  mn: "Бүх ангилал",
  ug: "بارلىق تۈرلەر",
  default: "All categories"
};
export default {
  name: "product-module-new",
  data() {
    return {
      msg: "测试",
      tabList: ["Forex", "Indices", "Commodities", "Stock CFDs", "ETF CFDs"],
      tableData: [
        {
          tabName: "Forex",
          datas: [
            { symbol: "EURUSD", tick: [], symbolZh: '欧元/美元', symbolFan: '歐元/美元' },
            { symbol: "AUDUSD", tick: [], symbolZh: '澳元/美元', symbolFan: '澳元/美元' },
            { symbol: "GBPUSD", tick: [], symbolZh: '英镑/美元', symbolFan: '英鎊/美元' },
            { symbol: "NZDUSD", tick: [], symbolZh: '纽元/美元', symbolFan: '紐元/美元' },
            { symbol: "USDCAD", tick: [], symbolZh: '美元/瑞郎', symbolFan: '美元/瑞郎' },
            { symbol: "USDJPY", tick: [], symbolZh: '美元/加元', symbolFan: '美元/加元' },
            { symbol: "USDCHF", tick: [], symbolZh: '美元/日元', symbolFan: '英鎊/日圓' },
            { symbol: "GBPAUD", tick: [], symbolZh: '英镑/澳元', symbolFan: '英鎊/澳元' },
            { symbol: "GBPJPY", tick: [], symbolZh: '英镑/日元', symbolFan: '英鎊/日圓' },
            { symbol: "AUDCAD", tick: [], symbolZh: '澳元/加元', symbolFan: '澳元/加元' },
            { symbol: "AUDCHF", tick: [], symbolZh: '澳元/瑞郎', symbolFan: '澳元/瑞郎' },
            { symbol: "AUDJPY", tick: [], symbolZh: '澳元/日元', symbolFan: '澳元/日圓' },
            { symbol: "AUDNZD", tick: [], symbolZh: '澳元/纽元', symbolFan: '澳元/紐元' },
            { symbol: "CADCHF", tick: [], symbolZh: '加元/瑞郎', symbolFan: '加元/瑞郎' },
            { symbol: "CADJPY", tick: [], symbolZh: '加元/日元', symbolFan: '加元/日圓' },
            { symbol: "CHFJPY", tick: [], symbolZh: '瑞郎/日元', symbolFan: '瑞郎/日圓' },
            { symbol: "EURAUD", tick: [], symbolZh: '欧元/澳元', symbolFan: '歐元/澳元' },
            { symbol: "EURCAD", tick: [], symbolZh: '欧元/加元', symbolFan: '歐元/加元' },
            { symbol: "EURCHF", tick: [], symbolZh: '欧元/瑞郎', symbolFan: '歐元/瑞郎' },
            { symbol: "EURGBP", tick: [], symbolZh: '欧元/英镑', symbolFan: '歐元/英鎊' },
            { symbol: "EURJPY", tick: [], symbolZh: '欧元/日元', symbolFan: '歐元/日圓' },
            { symbol: "EURNZD", tick: [], symbolZh: '欧元/纽元', symbolFan: '歐元/紐元' },
            { symbol: "GBPCAD", tick: [], symbolZh: '英镑/加元', symbolFan: '英鎊/加元' },
            { symbol: "GBPCHF", tick: [], symbolZh: '英镑/瑞郎', symbolFan: '英鎊/瑞郎' },
            { symbol: "GBPNZD", tick: [], symbolZh: '英镑/纽元', symbolFan: '英鎊/紐元' },
            { symbol: "NZDCAD", tick: [], symbolZh: '纽元/加元', symbolFan: '紐元/加元' },
            { symbol: "NZDCHF", tick: [], symbolZh: '纽元/瑞郎', symbolFan: '紐元/瑞郎' },
            { symbol: "NZDJPY", tick: [], symbolZh: '纽元/日元', symbolFan: '紐元/日圓' },
            { symbol: "USDCNH", tick: [], symbolZh: '美元/离岸人民币', symbolFan: '美元/離岸人民幣' },
            { symbol: "USDHKD", tick: [], symbolZh: '美元/港币', symbolFan: '美元/港元' },
            { symbol: "USDMXN", tick: [], symbolZh: '美元/墨西哥比索', symbolFan: '美元/墨西哥披索' },
            { symbol: "USDNOK", tick: [], symbolZh: '美元/挪威克朗', symbolFan: '美元/挪威克朗' },
          ],
        },
        {
          tabName: "Indices",
          datas: [
            { symbol: "100GBP", tick: [], symbolZh: '富时100指数', symbolFan: '富時100指數' },
            { symbol: "200AUD", tick: [], symbolZh: 'S&P200指数', symbolFan: 'S&P200指數' },
            { symbol: "225JPY", tick: [], symbolZh: '日经225指数', symbolFan: '日經225指數' },
            { symbol: "D30EUR", tick: [], symbolZh: 'DAX30指数', symbolFan: 'DAX30指數' },
            { symbol: "E50EUR", tick: [], symbolZh: 'STOXX50指数', symbolFan: 'STOXX50指數' },
            { symbol: "F40EUR", tick: [], symbolZh: 'CAC40指数', symbolFan: 'CAC40指數' },
            { symbol: "HSIHKD", tick: [], symbolZh: '恒生指数', symbolFan: '恒生指數' },
            { symbol: "NASUSD", tick: [], symbolZh: '纳斯达克指数', symbolFan: '納斯達克指數' },
            { symbol: "SPXUSD", tick: [], symbolZh: '标普500指数', symbolFan: '標普500指數' },
            { symbol: "U30USD", tick: [], symbolZh: '道琼斯指数', symbolFan: '道瓊斯指數' },
            { symbol: "CNIUSD", tick: [], symbolZh: '中国A50指数', symbolFan: '中國A50指數' },
            { symbol: "RUTUSD", tick: [], symbolZh: '罗素2000指数', symbolFan: '羅素2000指數' },
          ],
        },
        {
          tabName: "Commodities",
          datas: [
            { symbol: "XAUUSD", tick: [], symbolZh: '黄金/美元', symbolFan: '黃金/美元' },
            { symbol: "XAGUSD", tick: [], symbolZh: '白银/美元', symbolFan: '白銀/美元' },
            { symbol: "XBRUSD", tick: [], symbolZh: '布伦特原油', symbolFan: '布倫特原油' },
            { symbol: "XTIUSD", tick: [], symbolZh: 'WTI原油', symbolFan: 'WTI原油' },
            { symbol: "XNGUSD", tick: [], symbolZh: '天然气', symbolFan: '天然氣' },
          ],
        },
        {
          tabName: "Stock CFDs",
          datas: [
  {
    "symbol": "NVDA",
    "symbolEn": "NVIDIA Corporation",
    "symbolZh": "英伟达公司",
    "symbolFan": "英偉達公司",
    "stockData": {
      "lanTypes": {
        "zh-cn": "电子科技",
        "id": "Teknologi Elektronik",
        "ru": "Электронные технологии",
        "es": "Tecnología electrónica",
        "pt": "Tecnologia eletrônica",
        "th": "เทคโนโลยีอิเลคทรอนิกส์",
        "vi": "Công nghệ điện tử",
        "jp": "電子テクノロジー",
        "kr": "전자 기술",
        "zh": "電子科技",
        "ar": "التكنولوجيا الإلكترونية",
        "default": "Electronic technology"
      },
      "perData": {
        "monthData": "-3.72%",
        "yearData": "+25.78%"
      }
    }
  },
  {
    "symbol": "INTC",
    "symbolEn": "Intel Corporation",
    "symbolZh": "英特尔公司",
    "symbolFan": "英特爾公司",
    "stockData": {
      "lanTypes": {
        "zh-cn": "电子科技",
        "id": "Teknologi Elektronik",
        "ru": "Электронные технологии",
        "es": "Tecnología electrónica",
        "pt": "Tecnologia eletrônica",
        "th": "เทคโนโลยีอิเลคทรอนิกส์",
        "vi": "Công nghệ điện tử",
        "jp": "電子テクノロジー",
        "kr": "전자 기술",
        "zh": "電子科技",
        "ar": "التكنولوجيا الإلكترونية",
        "default": "Electronic technology"
      },
      "perData": {
        "monthData": "-0.40%",
        "yearData": "+383.21%"
      }
    }
  },
  {
    "symbol": "TXN",
    "symbolEn": "Texas Instruments Incorporated",
    "symbolZh": "德州仪器公司",
    "symbolFan": "德州儀器公司",
    "stockData": {
      "lanTypes": {
        "zh-cn": "电子科技",
        "id": "Teknologi Elektronik",
        "ru": "Электронные технологии",
        "es": "Tecnología electrónica",
        "pt": "Tecnologia eletrônica",
        "th": "เทคโนโลยีอิเลคทรอนิกส์",
        "vi": "Công nghệ điện tử",
        "jp": "電子テクノロジー",
        "kr": "전자 기술",
        "zh": "電子科技",
        "ar": "التكنولوجيا الإلكترونية",
        "default": "Electronic technology"
      },
      "perData": {
        "monthData": "+3.59%",
        "yearData": "+42.22%"
      }
    }
  },
  {
    "symbol": "CSCO",
    "symbolEn": "Cisco Systems, Inc.",
    "symbolZh": "思科",
    "symbolFan": "思科",
    "stockData": {
      "lanTypes": {
        "zh-cn": "电子科技",
        "id": "Teknologi Elektronik",
        "ru": "Электронные технологии",
        "es": "Tecnología electrónica",
        "pt": "Tecnologia eletrônica",
        "th": "เทคโนโลยีอิเลคทรอนิกส์",
        "vi": "Công nghệ điện tử",
        "jp": "電子テクノロジー",
        "kr": "전자 기술",
        "zh": "電子科技",
        "ar": "التكنولوجيا الإلكترونية",
        "default": "Electronic technology"
      },
      "perData": {
        "monthData": "-4.02%",
        "yearData": "+72.61%"
      }
    }
  },
  {
    "symbol": "AAPL",
    "symbolEn": "Apple Inc.",
    "symbolZh": "苹果公司",
    "symbolFan": "蘋果公司",
    "stockData": {
      "lanTypes": {
        "zh-cn": "电子科技",
        "id": "Teknologi Elektronik",
        "ru": "Электронные технологии",
        "es": "Tecnología electrónica",
        "pt": "Tecnologia eletrônica",
        "th": "เทคโนโลยีอิเลคทรอนิกส์",
        "vi": "Công nghệ điện tử",
        "jp": "電子テクノロジー",
        "kr": "전자 기술",
        "zh": "電子科技",
        "ar": "التكنولوجيا الإلكترونية",
        "default": "Electronic technology"
      },
      "perData": {
        "monthData": "+5.31%",
        "yearData": "+50.92%"
      }
    }
  },
  {
    "symbol": "MSFT",
    "symbolEn": "Microsoft Corporation",
    "symbolZh": "微软公司",
    "symbolFan": "微軟公司",
    "stockData": {
      "lanTypes": {
        "zh-cn": "科技服务",
        "id": "Layanan Teknologi",
        "ru": "Технологии",
        "es": "Servicios tecnológicos",
        "pt": "Serviços de tecnologia",
        "th": "บริการทางด้านเทคโนโลยี",
        "vi": "Dịch vụ công nghệ",
        "jp": "テクノロジーサービス",
        "kr": "기술 서비스",
        "zh": "科技服務",
        "ar": "خدمات التكنولوجيا",
        "default": "Technology services"
      },
      "perData": {
        "monthData": "-6.03%",
        "yearData": "-23.17%"
      }
    }
  },
  {
    "symbol": "GOOGL",
    "extraSymbol": "GOOG",
    "symbolEn": "Alphabet Inc.",
    "symbolZh": "谷歌A",
    "symbolFan": "谷歌A",
    "stockData": {
      "lanTypes": {
        "zh-cn": "科技服务",
        "id": "Layanan Teknologi",
        "ru": "Технологии",
        "es": "Servicios tecnológicos",
        "pt": "Serviços de tecnologia",
        "th": "บริการทางด้านเทคโนโลยี",
        "vi": "Dịch vụ công nghệ",
        "jp": "テクノロジーサービス",
        "kr": "기술 서비스",
        "zh": "科技服務",
        "ar": "خدمات التكنولوجيا",
        "default": "Technology services"
      },
      "perData": {
        "monthData": "-2.37%",
        "yearData": "+102.28%"
      }
    }
  },
  {
    "symbol": "META",
    "symbolEn": "Meta Platforms, Inc.",
    "symbolZh": "Meta公司",
    "symbolFan": "Meta公司",
    "stockData": {
      "lanTypes": {
        "zh-cn": "科技服务",
        "id": "Layanan Teknologi",
        "ru": "Технологии",
        "es": "Servicios tecnológicos",
        "pt": "Serviços de tecnologia",
        "th": "บริการทางด้านเทคโนโลยี",
        "vi": "Dịch vụ công nghệ",
        "jp": "テクノロジーサービス",
        "kr": "기술 서비스",
        "zh": "科技服務",
        "ar": "خدمات التكنولوجيا",
        "default": "Technology services"
      },
      "perData": {
        "monthData": "+6.85%",
        "yearData": "-12.62%"
      }
    }
  },
  {
    "symbol": "AMZN",
    "symbolEn": "Amazon.com, Inc.",
    "symbolZh": "亚马逊公司",
    "symbolFan": "亞馬遜公司",
    "stockData": {
      "lanTypes": {
        "zh-cn": "零售行业",
        "id": "Perdagangan Ritel",
        "ru": "Розничная торговля",
        "es": "Comercio minorista",
        "pt": "Comércio de varejo",
        "th": "การค้าปลีก",
        "vi": "Bán lẻ",
        "jp": "小売業",
        "kr": "소매업",
        "zh": "零售業",
        "ar": "تجارة التجزئة",
        "default": "Retail trade"
      },
      "perData": {
        "monthData": "-0.28%",
        "yearData": "+11.75%"
      }
    }
  },
  {
    "symbol": "ADBE",
    "symbolEn": "Adobe Inc.",
    "symbolZh": "Adobe",
    "symbolFan": "Adobe",
    "stockData": {
      "lanTypes": {
        "zh-cn": "科技服务",
        "id": "Layanan Teknologi",
        "ru": "Технологии",
        "es": "Servicios tecnológicos",
        "pt": "Serviços de tecnologia",
        "th": "บริการทางด้านเทคโนโลยี",
        "vi": "Dịch vụ công nghệ",
        "jp": "テクノロジーサービス",
        "kr": "기술 서비스",
        "zh": "科技服務",
        "ar": "خدمات التكنولوجيا",
        "default": "Technology services"
      },
      "perData": {
        "monthData": "-8.37%",
        "yearData": "-41.94%"
      }
    }
  },
  {
    "symbol": "CRM",
    "symbolEn": "Salesforce, Inc.",
    "symbolZh": "Salesforce",
    "symbolFan": "Salesforce",
    "stockData": {
      "lanTypes": {
        "zh-cn": "科技服务",
        "id": "Layanan Teknologi",
        "ru": "Технологии",
        "es": "Servicios tecnológicos",
        "pt": "Serviços de tecnologia",
        "th": "บริการทางด้านเทคโนโลยี",
        "vi": "Dịch vụ công nghệ",
        "jp": "テクノロジーサービス",
        "kr": "기술 서비스",
        "zh": "科技服務",
        "ar": "خدمات التكنولوجيا",
        "default": "Technology services"
      },
      "perData": {
        "monthData": "-9.47%",
        "yearData": "-40.77%"
      }
    }
  },
  {
    "symbol": "IBM",
    "symbolEn": "International Business Machines Corporation",
    "symbolZh": "IBM",
    "symbolFan": "IBM",
    "stockData": {
      "lanTypes": {
        "zh-cn": "科技服务",
        "id": "Layanan Teknologi",
        "ru": "Технологии",
        "es": "Servicios tecnológicos",
        "pt": "Serviços de tecnologia",
        "th": "บริการทางด้านเทคโนโลยี",
        "vi": "Dịch vụ công nghệ",
        "jp": "テクノロジーサービス",
        "kr": "기술 서비스",
        "zh": "科技服務",
        "ar": "خدمات التكنولوجيا",
        "default": "Technology services"
      },
      "perData": {
        "monthData": "+5.04%",
        "yearData": "+1.34%"
      }
    }
  },
  {
    "symbol": "PYPL",
    "symbolEn": "PayPal Holdings, Inc.",
    "symbolZh": "PayPal",
    "symbolFan": "PayPal",
    "stockData": {
      "lanTypes": {
        "zh-cn": "商业服务",
        "id": "Layanan Komersil",
        "ru": "Коммерческие услуги",
        "es": "Servicios comerciales",
        "pt": "Serviços comerciais",
        "th": "บริการเชิงพาณิชย์",
        "vi": "Dịch vụ thương mại",
        "jp": "商業サービス",
        "kr": "상업 서비스",
        "zh": "商業服務",
        "ar": "الخدمات التجارية",
        "default": "Commercial services"
      },
      "perData": {
        "monthData": "+10.09%",
        "yearData": "-39.97%"
      }
    }
  },
  {
    "symbol": "SPCX",
    "symbolEn": "SpaceX",
    "symbolZh": "SpaceX",
    "symbolFan": "SpaceX",
    "stockData": {
      "lanTypes": {
        "zh-cn": "通讯",
        "id": "Komunikasi",
        "ru": "Связь",
        "es": "Comunicaciones",
        "pt": "Comunicações",
        "th": "การสื่อสาร",
        "vi": "Truyền thông",
        "jp": "通信",
        "kr": "커뮤니케이션",
        "zh": "通訊",
        "ar": "الاتصالات",
        "default": "Communications"
      },
      "perData": {
        "monthData": "+1.44%",
        "yearData": "+1.44%"
      }
    }
  },
  {
    "symbol": "TSLA",
    "symbolEn": "Tesla, Inc.",
    "symbolZh": "特斯拉公司",
    "symbolFan": "特斯拉公司",
    "stockData": {
      "lanTypes": {
        "zh-cn": "耐用消费品",
        "id": "Konsumer Tahan Lama",
        "ru": "Потребительские товары длительного пользования",
        "es": "Bienes de consumo duraderos",
        "pt": "Consumo de duráveis",
        "th": "สินค้าอุปโภคบริโภคที่คงทนถาวร",
        "vi": "Hàng tiêu dùng lâu bền",
        "jp": "耐久消費財",
        "kr": "소비자 내구재",
        "zh": "耐用消費品",
        "ar": "السلع الاستهلاكية المُعمرة",
        "default": "Consumer durables"
      },
      "perData": {
        "monthData": "-1.09%",
        "yearData": "+36.63%"
      }
    }
  },
  {
    "symbol": "NFLX",
    "symbolEn": "Netflix, Inc.",
    "symbolZh": "奈飞公司",
    "symbolFan": "奈飛公司",
    "stockData": {
      "lanTypes": {
        "zh-cn": "科技服务",
        "id": "Layanan Teknologi",
        "ru": "Технологии",
        "es": "Servicios tecnológicos",
        "pt": "Serviços de tecnologia",
        "th": "บริการทางด้านเทคโนโลยี",
        "vi": "Dịch vụ công nghệ",
        "jp": "テクノロジーサービス",
        "kr": "기술 서비스",
        "zh": "科技服務",
        "ar": "خدمات التكنولوجيا",
        "default": "Technology services"
      },
      "perData": {
        "monthData": "-8.10%",
        "yearData": "-40.76%"
      }
    }
  },
  {
    "symbol": "CMCSA",
    "symbolEn": "Comcast Corporation",
    "symbolZh": "康卡斯特公司",
    "symbolFan": "康卡斯特公司",
    "stockData": {
      "lanTypes": {
        "zh-cn": "消费者服务",
        "id": "Layanan Konsumen",
        "ru": "Потребительские услуги",
        "es": "Servicios al consumidor",
        "pt": "Consumo de serviços",
        "th": "บริการผู้บริโภค",
        "vi": "Dịch vụ Khách hàng",
        "jp": "消費者サービス",
        "kr": "소비자 서비스",
        "zh": "消費者服務",
        "ar": "خدمات المستهلك",
        "default": "Consumer services"
      },
      "perData": {
        "monthData": "-1.79%",
        "yearData": "-30.63%"
      }
    }
  },
  {
    "symbol": "DIS",
    "symbolEn": "The Walt Disney Company",
    "symbolZh": "华特迪士尼公司",
    "symbolFan": "華特迪士尼公司",
    "stockData": {
      "lanTypes": {
        "zh-cn": "消费者服务",
        "id": "Layanan Konsumen",
        "ru": "Потребительские услуги",
        "es": "Servicios al consumidor",
        "pt": "Consumo de serviços",
        "th": "บริการผู้บริโภค",
        "vi": "Dịch vụ Khách hàng",
        "jp": "消費者サービス",
        "kr": "소비자 서비스",
        "zh": "消費者服務",
        "ar": "خدمات المستهلك",
        "default": "Consumer services"
      },
      "perData": {
        "monthData": "-2.91%",
        "yearData": "-21.07%"
      }
    }
  },
  {
    "symbol": "LLY",
    "symbolEn": "Eli Lilly and Company",
    "symbolZh": "礼来公司",
    "symbolFan": "禮來公司",
    "stockData": {
      "lanTypes": {
        "zh-cn": "健康科技",
        "id": "Teknologi Kesehatan",
        "ru": "Медицинские технологии",
        "es": "Tecnologías sanitarias",
        "pt": "Tecnologia em saúde",
        "th": "เทคโนโลยีเกี่ยวกับสุขภาพ",
        "vi": "Công nghệ y tế",
        "jp": "ヘルスケアテクノロジー",
        "kr": "의료 기술",
        "zh": "健康科技",
        "ar": "تكنولوجيا الصحة",
        "default": "Health technology"
      },
      "perData": {
        "monthData": "+4.46%",
        "yearData": "+55.26%"
      }
    }
  },
  {
    "symbol": "UNH",
    "symbolEn": "UnitedHealth Group Incorporated",
    "symbolZh": "美国联合健康集团",
    "symbolFan": "美國聯合健康集團",
    "stockData": {
      "lanTypes": {
        "zh-cn": "健康服务",
        "id": "Layanan Kesehatan",
        "ru": "Здравоохранение",
        "es": "Servicios de salud",
        "pt": "Serviços de saúde",
        "th": "บริการเกี่ยวกับสุขภาพ",
        "vi": "Dịch vụ y tế",
        "jp": "ヘルスケアサービス",
        "kr": "보건 서비스",
        "zh": "健康服務",
        "ar": "الخدمات الصحية",
        "default": "Health services"
      },
      "perData": {
        "monthData": "+5.29%",
        "yearData": "+42.38%"
      }
    }
  },
  {
    "symbol": "JNJ",
    "symbolEn": "Johnson & Johnson",
    "symbolZh": "强生公司",
    "symbolFan": "強生公司",
    "stockData": {
      "lanTypes": {
        "zh-cn": "健康科技",
        "id": "Teknologi Kesehatan",
        "ru": "Медицинские технологии",
        "es": "Tecnologías sanitarias",
        "pt": "Tecnologia em saúde",
        "th": "เทคโนโลยีเกี่ยวกับสุขภาพ",
        "vi": "Công nghệ y tế",
        "jp": "ヘルスケアテクノロジー",
        "kr": "의료 기술",
        "zh": "健康科技",
        "ar": "تكنولوجيا الصحة",
        "default": "Health technology"
      },
      "perData": {
        "monthData": "+11.50%",
        "yearData": "+66.31%"
      }
    }
  },
  {
    "symbol": "ABT",
    "symbolEn": "Abbott Laboratories",
    "symbolZh": "雅培",
    "symbolFan": "雅培",
    "stockData": {
      "lanTypes": {
        "zh-cn": "健康科技",
        "id": "Teknologi Kesehatan",
        "ru": "Медицинские технологии",
        "es": "Tecnologías sanitarias",
        "pt": "Tecnologia em saúde",
        "th": "เทคโนโลยีเกี่ยวกับสุขภาพ",
        "vi": "Công nghệ y tế",
        "jp": "ヘルスケアテクノロジー",
        "kr": "의료 기술",
        "zh": "健康科技",
        "ar": "تكنولوجيا الصحة",
        "default": "Health technology"
      },
      "perData": {
        "monthData": "+4.05%",
        "yearData": "-29.27%"
      }
    }
  },
  {
    "symbol": "MRK",
    "symbolEn": "Merck & Co., Inc.",
    "symbolZh": "默克公司",
    "symbolFan": "默克公司",
    "stockData": {
      "lanTypes": {
        "zh-cn": "健康科技",
        "id": "Teknologi Kesehatan",
        "ru": "Медицинские технологии",
        "es": "Tecnologías sanitarias",
        "pt": "Tecnologia em saúde",
        "th": "เทคโนโลยีเกี่ยวกับสุขภาพ",
        "vi": "Công nghệ y tế",
        "jp": "ヘルスケアテクノロジー",
        "kr": "의료 기술",
        "zh": "健康科技",
        "ar": "تكنولوجيا الصحة",
        "default": "Health technology"
      },
      "perData": {
        "monthData": "+4.20%",
        "yearData": "+51.82%"
      }
    }
  },
  {
    "symbol": "PFE",
    "symbolEn": "Pfizer Inc.",
    "symbolZh": "辉瑞公司",
    "symbolFan": "輝瑞公司",
    "stockData": {
      "lanTypes": {
        "zh-cn": "健康科技",
        "id": "Teknologi Kesehatan",
        "ru": "Медицинские технологии",
        "es": "Tecnologías sanitarias",
        "pt": "Tecnologia em saúde",
        "th": "เทคโนโลยีเกี่ยวกับสุขภาพ",
        "vi": "Công nghệ y tế",
        "jp": "ヘルスケアテクノロジー",
        "kr": "의료 기술",
        "zh": "健康科技",
        "ar": "تكنولوجيا الصحة",
        "default": "Health technology"
      },
      "perData": {
        "monthData": "-5.73%",
        "yearData": "-5.61%"
      }
    }
  },
  {
    "symbol": "BMY",
    "symbolEn": "Bristol-Myers Squibb Company",
    "symbolZh": "百时美施贵宝公司",
    "symbolFan": "百時美施貴寶公司",
    "stockData": {
      "lanTypes": {
        "zh-cn": "健康科技",
        "id": "Teknologi Kesehatan",
        "ru": "Медицинские технологии",
        "es": "Tecnologías sanitarias",
        "pt": "Tecnologia em saúde",
        "th": "เทคโนโลยีเกี่ยวกับสุขภาพ",
        "vi": "Công nghệ y tế",
        "jp": "ヘルスケアテクノロジー",
        "kr": "의료 기술",
        "zh": "健康科技",
        "ar": "تكنولوجيا الصحة",
        "default": "Health technology"
      },
      "perData": {
        "monthData": "+3.41%",
        "yearData": "+22.75%"
      }
    }
  },
  {
    "symbol": "MDT",
    "symbolEn": "Medtronic plc",
    "symbolZh": "美敦力公司",
    "symbolFan": "美敦力公司",
    "stockData": {
      "lanTypes": {
        "zh-cn": "健康科技",
        "id": "Teknologi Kesehatan",
        "ru": "Медицинские технологии",
        "es": "Tecnologías sanitarias",
        "pt": "Tecnologia em saúde",
        "th": "เทคโนโลยีเกี่ยวกับสุขภาพ",
        "vi": "Công nghệ y tế",
        "jp": "ヘルスケアテクノロジー",
        "kr": "의료 기술",
        "zh": "健康科技",
        "ar": "تكنولوجيا الصحة",
        "default": "Health technology"
      },
      "perData": {
        "monthData": "+2.02%",
        "yearData": "-7.25%"
      }
    }
  },
  {
    "symbol": "AMGN",
    "symbolEn": "Amgen Inc.",
    "symbolZh": "安进公司",
    "symbolFan": "安進公司",
    "stockData": {
      "lanTypes": {
        "zh-cn": "健康科技",
        "id": "Teknologi Kesehatan",
        "ru": "Медицинские технологии",
        "es": "Tecnologías sanitarias",
        "pt": "Tecnologia em saúde",
        "th": "เทคโนโลยีเกี่ยวกับสุขภาพ",
        "vi": "Công nghệ y tế",
        "jp": "ヘルスケアテクノロジー",
        "kr": "의료 기술",
        "zh": "健康科技",
        "ar": "تكنولوجيا الصحة",
        "default": "Health technology"
      },
      "perData": {
        "monthData": "+4.42%",
        "yearData": "+21.81%"
      }
    }
  },
  {
    "symbol": "JPM",
    "symbolEn": "JPMorgan Chase & Co.",
    "symbolZh": "摩根大通集团",
    "symbolFan": "摩根大通集團",
    "stockData": {
      "lanTypes": {
        "zh-cn": "金融",
        "id": "Keuangan",
        "ru": "Финансы",
        "es": "Finanzas",
        "pt": "Financeiro",
        "th": "การเงิน",
        "vi": "Tài chính",
        "jp": "金融",
        "kr": "금융",
        "zh": "金融",
        "ar": "القطاع المالي",
        "default": "Finance"
      },
      "perData": {
        "monthData": "+7.00%",
        "yearData": "+16.82%"
      }
    }
  },
  {
    "symbol": "GS",
    "symbolEn": "The Goldman Sachs Group, Inc.",
    "symbolZh": "高盛集团",
    "symbolFan": "高盛集團",
    "stockData": {
      "lanTypes": {
        "zh-cn": "金融",
        "id": "Keuangan",
        "ru": "Финансы",
        "es": "Finanzas",
        "pt": "Financeiro",
        "th": "การเงิน",
        "vi": "Tài chính",
        "jp": "金融",
        "kr": "금융",
        "zh": "金融",
        "ar": "القطاع المالي",
        "default": "Finance"
      },
      "perData": {
        "monthData": "-0.55%",
        "yearData": "+49.92%"
      }
    }
  },
  {
    "symbol": "MS",
    "symbolEn": "Morgan Stanley",
    "symbolZh": "摩根士丹利",
    "symbolFan": "摩根士丹利",
    "stockData": {
      "lanTypes": {
        "zh-cn": "金融",
        "id": "Keuangan",
        "ru": "Финансы",
        "es": "Finanzas",
        "pt": "Financeiro",
        "th": "การเงิน",
        "vi": "Tài chính",
        "jp": "金融",
        "kr": "금융",
        "zh": "金融",
        "ar": "القطاع المالي",
        "default": "Finance"
      },
      "perData": {
        "monthData": "+3.60%",
        "yearData": "+55.44%"
      }
    }
  },
  {
    "symbol": "BAC",
    "symbolEn": "Bank of America Corporation",
    "symbolZh": "美国银行",
    "symbolFan": "美國銀行",
    "stockData": {
      "lanTypes": {
        "zh-cn": "金融",
        "id": "Keuangan",
        "ru": "Финансы",
        "es": "Finanzas",
        "pt": "Financeiro",
        "th": "การเงิน",
        "vi": "Tài chính",
        "jp": "金融",
        "kr": "금융",
        "zh": "金融",
        "ar": "القطاع المالي",
        "default": "Finance"
      },
      "perData": {
        "monthData": "+9.72%",
        "yearData": "+25.64%"
      }
    }
  },
  {
    "symbol": "MA",
    "symbolEn": "Mastercard Incorporated",
    "symbolZh": "万事达卡公司",
    "symbolFan": "萬事達卡公司",
    "stockData": {
      "lanTypes": {
        "zh-cn": "金融",
        "id": "Keuangan",
        "ru": "Финансы",
        "es": "Finanzas",
        "pt": "Financeiro",
        "th": "การเงิน",
        "vi": "Tài chính",
        "jp": "金融",
        "kr": "금융",
        "zh": "金融",
        "ar": "القطاع المالي",
        "default": "Finance"
      },
      "perData": {
        "monthData": "+8.12%",
        "yearData": "-6.90%"
      }
    }
  },
  {
    "symbol": "V",
    "symbolEn": "Visa Inc.",
    "symbolZh": "Visa",
    "symbolFan": "Visa",
    "stockData": {
      "lanTypes": {
        "zh-cn": "金融",
        "id": "Keuangan",
        "ru": "Финансы",
        "es": "Finanzas",
        "pt": "Financeiro",
        "th": "การเงิน",
        "vi": "Tài chính",
        "jp": "金融",
        "kr": "금융",
        "zh": "金融",
        "ar": "القطاع المالي",
        "default": "Finance"
      },
      "perData": {
        "monthData": "+9.27%",
        "yearData": "-1.93%"
      }
    }
  },
  {
    "symbol": "BRKb",
    "symbolEn": "Berkshire Hathaway Inc.",
    "symbolZh": "伯克希尔哈撒韦公司",
    "symbolFan": "伯克希爾哈撒韋公司",
    "stockData": {
      "lanTypes": {
        "zh-cn": "金融",
        "id": "Keuangan",
        "ru": "Финансы",
        "es": "Finanzas",
        "pt": "Financeiro",
        "th": "การเงิน",
        "vi": "Tài chính",
        "jp": "金融",
        "kr": "금융",
        "zh": "金融",
        "ar": "القطاع المالي",
        "default": "Finance"
      },
      "perData": {
        "monthData": "+1.78%",
        "yearData": "+3.65%"
      }
    }
  },
  {
    "symbol": "BA",
    "symbolEn": "The Boeing Company",
    "symbolZh": "波音公司",
    "symbolFan": "波音公司",
    "stockData": {
      "lanTypes": {
        "zh-cn": "电子科技",
        "id": "Teknologi Elektronik",
        "ru": "Электронные технологии",
        "es": "Tecnología electrónica",
        "pt": "Tecnologia eletrônica",
        "th": "เทคโนโลยีอิเลคทรอนิกส์",
        "vi": "Công nghệ điện tử",
        "jp": "電子テクノロジー",
        "kr": "전자 기술",
        "zh": "電子科技",
        "ar": "التكنولوجيا الإلكترونية",
        "default": "Electronic technology"
      },
      "perData": {
        "monthData": "+3.05%",
        "yearData": "+1.36%"
      }
    }
  },
  {
    "symbol": "CAT",
    "symbolEn": "Caterpillar Inc.",
    "symbolZh": "卡特彼勒公司",
    "symbolFan": "卡特彼勒公司",
    "stockData": {
      "lanTypes": {
        "zh-cn": "制造业",
        "id": "Produsen Pabrikan",
        "ru": "Промышленное производство",
        "es": "Fabricación de productos",
        "pt": "Produtor manufatureiro",
        "th": "การผลิตของผู้ผลิต",
        "vi": "Công nghiệp chế tạo",
        "jp": "生産財製造",
        "kr": "생산자 제조",
        "zh": "生產製造",
        "ar": "الصناعات الموجهة للمنتجين",
        "default": "Producer manufacturing"
      },
      "perData": {
        "monthData": "+1.18%",
        "yearData": "+134.76%"
      }
    }
  },
  {
    "symbol": "GE",
    "symbolEn": "General Electric Company",
    "symbolZh": "通用电气公司",
    "symbolFan": "通用電氣公司",
    "stockData": {
      "lanTypes": {
        "zh-cn": "电子科技",
        "id": "Teknologi Elektronik",
        "ru": "Электронные технологии",
        "es": "Tecnología electrónica",
        "pt": "Tecnologia eletrônica",
        "th": "เทคโนโลยีอิเลคทรอนิกส์",
        "vi": "Công nghệ điện tử",
        "jp": "電子テクノロジー",
        "kr": "전자 기술",
        "zh": "電子科技",
        "ar": "التكنولوجيا الإلكترونية",
        "default": "Electronic technology"
      },
      "perData": {
        "monthData": "+10.59%",
        "yearData": "+44.20%"
      }
    }
  },
  {
    "symbol": "HON",
    "symbolEn": "Honeywell International Inc.",
    "symbolZh": "霍尼韦尔国际公司",
    "symbolFan": "霍尼韋爾國際公司",
    "stockData": {
      "lanTypes": {
        "zh-cn": "电子科技",
        "id": "Teknologi Elektronik",
        "ru": "Электронные технологии",
        "es": "Tecnología electrónica",
        "pt": "Tecnologia eletrônica",
        "th": "เทคโนโลยีอิเลคทรอนิกส์",
        "vi": "Công nghệ điện tử",
        "jp": "電子テクノロジー",
        "kr": "전자 기술",
        "zh": "電子科技",
        "ar": "التكنولوجيا الإلكترونية",
        "default": "Electronic technology"
      },
      "perData": {
        "monthData": "+0.13%",
        "yearData": "-6.02%"
      }
    }
  },
  {
    "symbol": "RTX",
    "symbolEn": "RTX Corporation",
    "symbolZh": "RTX",
    "symbolFan": "RTX",
    "stockData": {
      "lanTypes": {
        "zh-cn": "电子科技",
        "id": "Teknologi Elektronik",
        "ru": "Электронные технологии",
        "es": "Tecnología electrónica",
        "pt": "Tecnologia eletrônica",
        "th": "เทคโนโลยีอิเลคทรอนิกส์",
        "vi": "Công nghệ điện tử",
        "jp": "電子テクノロジー",
        "kr": "전자 기술",
        "zh": "電子科技",
        "ar": "التكنولوجيا الإلكترونية",
        "default": "Electronic technology"
      },
      "perData": {
        "monthData": "+9.07%",
        "yearData": "+33.95%"
      }
    }
  },
  {
    "symbol": "LMT",
    "symbolEn": "Lockheed Martin Corporation",
    "symbolZh": "洛克希德马丁公司",
    "symbolFan": "洛克希德馬丁公司",
    "stockData": {
      "lanTypes": {
        "zh-cn": "电子科技",
        "id": "Teknologi Elektronik",
        "ru": "Электронные технологии",
        "es": "Tecnología electrónica",
        "pt": "Tecnologia eletrônica",
        "th": "เทคโนโลยีอิเลคทรอนิกส์",
        "vi": "Công nghệ điện tử",
        "jp": "電子テクノロジー",
        "kr": "전자 기술",
        "zh": "電子科技",
        "ar": "التكنولوجيا الإلكترونية",
        "default": "Electronic technology"
      },
      "perData": {
        "monthData": "-0.14%",
        "yearData": "+11.36%"
      }
    }
  },
  {
    "symbol": "MMM",
    "symbolEn": "3M Company",
    "symbolZh": "3M",
    "symbolFan": "3M",
    "stockData": {
      "lanTypes": {
        "zh-cn": "制造业",
        "id": "Produsen Pabrikan",
        "ru": "Промышленное производство",
        "es": "Fabricación de productos",
        "pt": "Produtor manufatureiro",
        "th": "การผลิตของผู้ผลิต",
        "vi": "Công nghiệp chế tạo",
        "jp": "生産財製造",
        "kr": "생산자 제조",
        "zh": "生產製造",
        "ar": "الصناعات الموجهة للمنتجين",
        "default": "Producer manufacturing"
      },
      "perData": {
        "monthData": "+0.69%",
        "yearData": "+0.62%"
      }
    }
  },
  {
    "symbol": "CVX",
    "symbolEn": "Chevron Corporation",
    "symbolZh": "雪佛龙公司",
    "symbolFan": "雪佛龍公司",
    "stockData": {
      "lanTypes": {
        "zh-cn": "能源矿产",
        "id": "Mineral Energi",
        "ru": "Энергетические и минеральные ресурсы",
        "es": "Minerales energéticos",
        "pt": "Minerais energéticos",
        "th": "แร่พลังงาน",
        "vi": "Khoáng sản năng lượng",
        "jp": "エネルギー鉱物",
        "kr": "에너지 광물",
        "zh": "能源礦產",
        "ar": "معادن الطاقة",
        "default": "Energy minerals"
      },
      "perData": {
        "monthData": "-7.67%",
        "yearData": "+13.80%"
      }
    }
  },
  {
    "symbol": "XOM",
    "symbolEn": "Exxon Mobil Corporation",
    "symbolZh": "埃克森美孚公司",
    "symbolFan": "埃克森美孚公司",
    "stockData": {
      "lanTypes": {
        "zh-cn": "能源矿产",
        "id": "Mineral Energi",
        "ru": "Энергетические и минеральные ресурсы",
        "es": "Minerales energéticos",
        "pt": "Minerais energéticos",
        "th": "แร่พลังงาน",
        "vi": "Khoáng sản năng lượng",
        "jp": "エネルギー鉱物",
        "kr": "에너지 광물",
        "zh": "能源礦產",
        "ar": "معادن الطاقة",
        "default": "Energy minerals"
      },
      "perData": {
        "monthData": "-8.91%",
        "yearData": "+20.66%"
      }
    }
  },
  {
    "symbol": "NEE",
    "symbolEn": "NextEra Energy, Inc.",
    "symbolZh": "NextEra能源公司",
    "symbolFan": "NextEra能源公司",
    "stockData": {
      "lanTypes": {
        "zh-cn": "公用事业",
        "id": "Utilitas",
        "ru": "Коммунальные услуги",
        "es": "Servicios públicos",
        "pt": "Serviços Públicos",
        "th": "สาธารณูปโภค",
        "vi": "Công ty dịch vụ công cộng",
        "jp": "公益事業",
        "kr": "유틸리티",
        "zh": "公用事業",
        "ar": "خدمات",
        "default": "Utilities"
      },
      "perData": {
        "monthData": "+3.55%",
        "yearData": "+19.53%"
      }
    }
  },
  {
    "symbol": "HD",
    "symbolEn": "The Home Depot, Inc.",
    "symbolZh": "家得宝公司",
    "symbolFan": "家得寶公司",
    "stockData": {
      "lanTypes": {
        "zh-cn": "零售行业",
        "id": "Perdagangan Ritel",
        "ru": "Розничная торговля",
        "es": "Comercio minorista",
        "pt": "Comércio de varejo",
        "th": "การค้าปลีก",
        "vi": "Bán lẻ",
        "jp": "小売業",
        "kr": "소매업",
        "zh": "零售業",
        "ar": "تجارة التجزئة",
        "default": "Retail trade"
      },
      "perData": {
        "monthData": "+8.79%",
        "yearData": "-7.83%"
      }
    }
  },
  {
    "symbol": "MCD",
    "symbolEn": "McDonald's Corporation",
    "symbolZh": "麦当劳",
    "symbolFan": "麥當勞",
    "stockData": {
      "lanTypes": {
        "zh-cn": "消费者服务",
        "id": "Layanan Konsumen",
        "ru": "Потребительские услуги",
        "es": "Servicios al consumidor",
        "pt": "Consumo de serviços",
        "th": "บริการผู้บริโภค",
        "vi": "Dịch vụ Khách hàng",
        "jp": "消費者サービス",
        "kr": "소비자 서비스",
        "zh": "消費者服務",
        "ar": "خدمات المستهلك",
        "default": "Consumer services"
      },
      "perData": {
        "monthData": "-0.40%",
        "yearData": "-5.39%"
      }
    }
  },
  {
    "symbol": "WMT",
    "symbolEn": "Walmart Inc.",
    "symbolZh": "沃尔玛公司",
    "symbolFan": "沃爾瑪公司",
    "stockData": {
      "lanTypes": {
        "zh-cn": "零售行业",
        "id": "Perdagangan Ritel",
        "ru": "Розничная торговля",
        "es": "Comercio minorista",
        "pt": "Comércio de varejo",
        "th": "การค้าปลีก",
        "vi": "Bán lẻ",
        "jp": "小売業",
        "kr": "소매업",
        "zh": "零售業",
        "ar": "تجارة التجزئة",
        "default": "Retail trade"
      },
      "perData": {
        "monthData": "-6.79%",
        "yearData": "+15.50%"
      }
    }
  },
  {
    "symbol": "PG",
    "symbolEn": "The Procter & Gamble Company",
    "symbolZh": "宝洁公司",
    "symbolFan": "寶潔公司",
    "stockData": {
      "lanTypes": {
        "zh-cn": "非耐用消费品",
        "id": "Konsumen tidak tahan lama",
        "ru": "Потребительские товары недлительного пользования",
        "es": "Consumibles perecederos",
        "pt": "Consumo de não duráveis",
        "th": "สินค้าอุปโภคบริโภคที่ไม่คงทนถาวร",
        "vi": "Hàng tiêu dùng không lâu bền",
        "jp": "非耐久消費財",
        "kr": "소비재 비내구재",
        "zh": "非耐用消費品",
        "ar": "مستهلك - غير معمرة",
        "default": "Consumer non-durables"
      },
      "perData": {
        "monthData": "+1.51%",
        "yearData": "-7.12%"
      }
    }
  },
  {
    "symbol": "KO",
    "symbolEn": "The Coca-Cola Company",
    "symbolZh": "可口可乐公司",
    "symbolFan": "可口可樂公司",
    "stockData": {
      "lanTypes": {
        "zh-cn": "非耐用消费品",
        "id": "Konsumen tidak tahan lama",
        "ru": "Потребительские товары недлительного пользования",
        "es": "Consumibles perecederos",
        "pt": "Consumo de não duráveis",
        "th": "สินค้าอุปโภคบริโภคที่ไม่คงทนถาวร",
        "vi": "Hàng tiêu dùng không lâu bền",
        "jp": "非耐久消費財",
        "kr": "소비재 비내구재",
        "zh": "非耐用消費品",
        "ar": "مستهلك - غير معمرة",
        "default": "Consumer non-durables"
      },
      "perData": {
        "monthData": "+3.87%",
        "yearData": "+17.77%"
      }
    }
  },
  {
    "symbol": "PEP",
    "symbolEn": "PepsiCo, Inc.",
    "symbolZh": "百事公司",
    "symbolFan": "百事公司",
    "stockData": {
      "lanTypes": {
        "zh-cn": "非耐用消费品",
        "id": "Konsumen tidak tahan lama",
        "ru": "Потребительские товары недлительного пользования",
        "es": "Consumibles perecederos",
        "pt": "Consumo de não duráveis",
        "th": "สินค้าอุปโภคบริโภคที่ไม่คงทนถาวร",
        "vi": "Hàng tiêu dùng không lâu bền",
        "jp": "非耐久消費財",
        "kr": "소비재 비내구재",
        "zh": "非耐用消費品",
        "ar": "مستهلك - غير معمرة",
        "default": "Consumer non-durables"
      },
      "perData": {
        "monthData": "-2.59%",
        "yearData": "+2.19%"
      }
    }
  },
  {
    "symbol": "VZ",
    "symbolEn": "Verizon Communications Inc.",
    "symbolZh": "威瑞森通信公司",
    "symbolFan": "威瑞森通信公司",
    "stockData": {
      "lanTypes": {
        "zh-cn": "通讯",
        "id": "Komunikasi",
        "ru": "Связь",
        "es": "Comunicaciones",
        "pt": "Comunicações",
        "th": "การสื่อสาร",
        "vi": "Truyền thông",
        "jp": "通信",
        "kr": "커뮤니케이션",
        "zh": "通訊",
        "ar": "الاتصالات",
        "default": "Communications"
      },
      "perData": {
        "monthData": "-6.73%",
        "yearData": "-1.73%"
      }
    }
  },
  {
    "symbol": "MU.OQ",
    "extraSymbol": "MU",
    "symbolEn": "Micron Technology, Inc.",
    "symbolZh": "美光科技",
    "symbolFan": "美光科技",
    "stockData": {
      "lanTypes": {
        "zh-cn": "电子科技",
        "id": "Teknologi Elektronik",
        "ru": "Электронные технологии",
        "es": "Tecnología electrónica",
        "pt": "Tecnologia eletrônica",
        "th": "เทคโนโลยีอิเลคทรอนิกส์",
        "vi": "Công nghệ điện tử",
        "jp": "電子テクノロジー",
        "kr": "전자 기술",
        "zh": "電子科技",
        "ar": "التكنولوجيا الإلكترونية",
        "default": "Electronic technology"
      },
      "perData": {
        "monthData": "+0.35%",
        "yearData": "+694.49%"
      }
    }
  },
  {
    "symbol": "AMD.OQ",
    "extraSymbol": "AMD",
    "symbolEn": "Advanced Micro Devices, Inc.",
    "symbolZh": "美国超微公司",
    "symbolFan": "美國超微公司",
    "stockData": {
      "lanTypes": {
        "zh-cn": "电子科技",
        "id": "Teknologi Elektronik",
        "ru": "Электронные технологии",
        "es": "Tecnología electrónica",
        "pt": "Tecnologia eletrônica",
        "th": "เทคโนโลยีอิเลคทรอนิกส์",
        "vi": "Công nghệ điện tử",
        "jp": "電子テクノロジー",
        "kr": "전자 기술",
        "zh": "電子科技",
        "ar": "التكنولوجيا الإلكترونية",
        "default": "Electronic technology"
      },
      "perData": {
        "monthData": "+8.75%",
        "yearData": "+294.20%"
      }
    }
  },
  {
    "symbol": "ASML.OQ",
    "extraSymbol": "ASML",
    "symbolEn": "ASML Holding N.V.",
    "symbolZh": "阿斯麦",
    "symbolFan": "阿斯麥",
    "stockData": {
      "lanTypes": {
        "zh-cn": "电子科技",
        "id": "Teknologi Elektronik",
        "ru": "Электронные технологии",
        "es": "Tecnología electrónica",
        "pt": "Tecnologia eletrônica",
        "th": "เทคโนโลยีอิเลคทรอนิกส์",
        "vi": "Công nghệ điện tử",
        "jp": "電子テクノロジー",
        "kr": "전자 기술",
        "zh": "電子科技",
        "ar": "التكنولوجيا الإلكترونية",
        "default": "Electronic technology"
      },
      "perData": {
        "monthData": "+1.56%",
        "yearData": "+127.55%"
      }
    }
  },
  {
    "symbol": "SNDK.OQ",
    "extraSymbol": "SNDK",
    "symbolEn": "Sandisk Corporation",
    "symbolZh": "闪迪",
    "symbolFan": "閃迪",
    "stockData": {
      "lanTypes": {
        "zh-cn": "电子科技",
        "id": "Teknologi Elektronik",
        "ru": "Электронные технологии",
        "es": "Tecnología electrónica",
        "pt": "Tecnologia eletrônica",
        "th": "เทคโนโลยีอิเลคทรอนิกส์",
        "vi": "Công nghệ điện tử",
        "jp": "電子テクノロジー",
        "kr": "전자 기술",
        "zh": "電子科技",
        "ar": "التكنولوجيا الإلكترونية",
        "default": "Electronic technology"
      },
      "perData": {
        "monthData": "+9.28%",
        "yearData": "+3929.21%"
      }
    }
  },
  {
    "symbol": "AVGO.OQ",
    "extraSymbol": "AVGO",
    "symbolEn": "Broadcom Inc.",
    "symbolZh": "博通",
    "symbolFan": "博通",
    "stockData": {
      "lanTypes": {
        "zh-cn": "电子科技",
        "id": "Teknologi Elektronik",
        "ru": "Электронные технологии",
        "es": "Tecnología electrónica",
        "pt": "Tecnologia eletrônica",
        "th": "เทคโนโลยีอิเลคทรอนิกส์",
        "vi": "Công nghệ điện tử",
        "jp": "電子テクノロジー",
        "kr": "전자 기술",
        "zh": "電子科技",
        "ar": "التكنولوجيا الإلكترونية",
        "default": "Electronic technology"
      },
      "perData": {
        "monthData": "-0.12%",
        "yearData": "+46.95%"
      }
    }
  },
  {
    "symbol": "COHR.N",
    "extraSymbol": "COHR",
    "symbolEn": "Coherent Corp.",
    "symbolZh": "高意",
    "symbolFan": "高意",
    "stockData": {
      "lanTypes": {
        "zh-cn": "电子科技",
        "id": "Teknologi Elektronik",
        "ru": "Электронные технологии",
        "es": "Tecnología electrónica",
        "pt": "Tecnologia eletrônica",
        "th": "เทคโนโลยีอิเลคทรอนิกส์",
        "vi": "Công nghệ điện tử",
        "jp": "電子テクノロジー",
        "kr": "전자 기술",
        "zh": "電子科技",
        "ar": "التكنولوجيا الإلكترونية",
        "default": "Electronic technology"
      },
      "perData": {
        "monthData": "-19.61%",
        "yearData": "+258.07%"
      }
    }
  },
  {
    "symbol": "MRVL.OQ",
    "extraSymbol": "MRVL",
    "symbolEn": "Marvell Technology, Inc.",
    "symbolZh": "迈威尔科技",
    "symbolFan": "邁威爾科技",
    "stockData": {
      "lanTypes": {
        "zh-cn": "电子科技",
        "id": "Teknologi Elektronik",
        "ru": "Электронные технологии",
        "es": "Tecnología electrónica",
        "pt": "Tecnologia eletrônica",
        "th": "เทคโนโลยีอิเลคทรอนิกส์",
        "vi": "Công nghệ điện tử",
        "jp": "電子テクノロジー",
        "kr": "전자 기술",
        "zh": "電子科技",
        "ar": "التكنولوجيا الإلكترونية",
        "default": "Electronic technology"
      },
      "perData": {
        "monthData": "-18.85%",
        "yearData": "+235.50%"
      }
    }
  },
  {
    "symbol": "LRCX.OQ",
    "extraSymbol": "LRCX",
    "symbolEn": "Lam Research Corporation",
    "symbolZh": "泛林集团",
    "symbolFan": "泛林集團",
    "stockData": {
      "lanTypes": {
        "zh-cn": "制造业",
        "id": "Produsen Pabrikan",
        "ru": "Промышленное производство",
        "es": "Fabricación de productos",
        "pt": "Produtor manufatureiro",
        "th": "การผลิตของผู้ผลิต",
        "vi": "Công nghiệp chế tạo",
        "jp": "生産財製造",
        "kr": "생산자 제조",
        "zh": "生產製造",
        "ar": "الصناعات الموجهة للمنتجين",
        "default": "Producer manufacturing"
      },
      "perData": {
        "monthData": "+5.27%",
        "yearData": "+253.88%"
      }
    }
  },
  {
    "symbol": "LIN.OQ",
    "extraSymbol": "LIN",
    "symbolEn": "Linde plc",
    "symbolZh": "林德",
    "symbolFan": "林德",
    "stockData": {
      "lanTypes": {
        "zh-cn": "加工制造业",
        "id": "Industri Proses",
        "ru": "Обрабатывающая промышленность",
        "es": "Industrias de proceso",
        "pt": "Industrias de processamento",
        "th": "อุตสาหกรรมเชิงกระบวนการ",
        "vi": "Công nghiệp chế biến",
        "jp": "素材産業",
        "kr": "공정 산업",
        "zh": "加工業",
        "ar": "الصناعات التحويلية",
        "default": "Process industries"
      },
      "perData": {
        "monthData": "+3.47%",
        "yearData": "+11.25%"
      }
    }
  },
  {
    "symbol": "QCOM.OQ",
    "extraSymbol": "QCOM",
    "symbolEn": "Qualcomm Inc",
    "symbolZh": "高通",
    "symbolFan": "高通",
    "stockData": {
      "lanTypes": {
        "zh-cn": "电子科技",
        "id": "Teknologi Elektronik",
        "ru": "Электронные технологии",
        "es": "Tecnología electrónica",
        "pt": "Tecnologia eletrônica",
        "th": "เทคโนโลยีอิเลคทรอนิกส์",
        "vi": "Công nghệ điện tử",
        "jp": "電子テクノロジー",
        "kr": "전자 기술",
        "zh": "電子科技",
        "ar": "التكنولوجيا الإلكترونية",
        "default": "Electronic technology"
      },
      "perData": {
        "monthData": "-11.71%",
        "yearData": "+19.89%"
      }
    }
  }
]
        },
        {
          tabName: "ETF CFDs",
          datas: [
  {
    "symbol": "AGG",
    "symbolEn": "iShares Core US Aggregate Bond ETF",
    "symbolZh": "美国全债市ETF-iShares",
    "symbolFan": "美國全債市ETF-iShares",
    "tick": [],
    "focus": "投资等级",
    "fundSize": "1381.17",
    "returns": {
      "total_return": "-3.32%",
      "10y": "-12.52%",
      "5y": "-14.42%",
      "3y": "+0.97%",
      "1y": "+0.08%"
    },
    "betas": {
      "beta_5y": "0.25",
      "beta_3y": "0.23",
      "beta_1y": "0.08"
    }
  },
  {
    "symbol": "BIL",
    "symbolEn": "SPDR Bloomberg Barclays 1-3 Month T-Bill ETF",
    "symbolZh": "1-3月美国国债ETF-SPDR",
    "symbolFan": "1-3月美國國債ETF-SPDR",
    "tick": [],
    "focus": "投资等级",
    "fundSize": "466.05",
    "returns": {
      "total_return": "-0.15%",
      "10y": "+0.02%",
      "5y": "-0.03%",
      "3y": "-0.02%",
      "1y": "-0.05%"
    },
    "betas": {
      "beta_5y": "0.00",
      "beta_3y": "0.00",
      "beta_1y": "0.01"
    }
  },
  {
    "symbol": "BSV",
    "symbolEn": "Vanguard Short-Term Bond Index Fund",
    "symbolZh": "美国短期债券ETF-Vanguard",
    "symbolFan": "美國短期債券ETF-Vanguard",
    "tick": [],
    "focus": "投资等级",
    "fundSize": "442.87",
    "returns": {
      "total_return": "+3.72%",
      "10y": "-4.13%",
      "5y": "-5.30%",
      "3y": "+3.19%",
      "1y": "-0.64%"
    },
    "betas": {
      "beta_5y": "0.09",
      "beta_3y": "0.06",
      "beta_1y": "0.03"
    }
  },
  {
    "symbol": "DGRO",
    "symbolEn": "iShares Core Dividend Growth ETF",
    "symbolZh": "安硕核心股利增长ETF",
    "symbolFan": "安碩核心股利增長ETF",
    "tick": [],
    "focus": "总市场",
    "fundSize": "414.34",
    "returns": {
      "total_return": "+211.53%",
      "10y": "+186.36%",
      "5y": "+52.12%",
      "3y": "+49.71%",
      "1y": "+18.72%"
    },
    "betas": {
      "beta_5y": "0.78",
      "beta_3y": "0.70",
      "beta_1y": "0.54"
    }
  },
  {
    "symbol": "DIA",
    "symbolEn": "SPDR Dow Jones Industrial Average ETF Trust",
    "symbolZh": "道琼斯指数ETF-SPDR",
    "symbolFan": "道瓊斯指數ETF-SPDR",
    "tick": [],
    "focus": "大盘",
    "fundSize": "443.64",
    "returns": {
      "total_return": "+578.40%",
      "10y": "+195.27%",
      "5y": "+52.11%",
      "3y": "+53.54%",
      "1y": "+18.45%"
    },
    "betas": {
      "beta_5y": "0.86",
      "beta_3y": "0.85",
      "beta_1y": "0.79"
    }
  },
  {
    "symbol": "EEM",
    "symbolEn": "iShares MSCI Emerging Markets ETF (USD)",
    "symbolZh": "新兴市场ETF-iShares",
    "symbolFan": "新興市場ETF-iShares",
    "tick": [],
    "focus": "总市场",
    "fundSize": "295.58",
    "returns": {
      "total_return": "+490.60%",
      "10y": "+89.77%",
      "5y": "+20.29%",
      "3y": "+63.17%",
      "1y": "+36.39%"
    },
    "betas": {
      "beta_5y": "0.73",
      "beta_3y": "0.82",
      "beta_1y": "1.32"
    }
  },
  {
    "symbol": "EFA",
    "symbolEn": "iShares MSCI EAFE ETF (USD)",
    "symbolZh": "欧澳远东指数ETF-iShares",
    "symbolFan": "歐澳遠東指數ETF-iShares",
    "tick": [],
    "focus": "总市场",
    "fundSize": "763.11",
    "returns": {
      "total_return": "+148.50%",
      "10y": "+86.91%",
      "5y": "+31.98%",
      "3y": "+43.87%",
      "1y": "+17.31%"
    },
    "betas": {
      "beta_5y": "0.78",
      "beta_3y": "0.63",
      "beta_1y": "0.94"
    }
  },
  {
    "symbol": "EWT",
    "symbolEn": "iShares MSCI TAIWAN ETF",
    "symbolZh": "安硕MSCI台湾ETF",
    "symbolFan": "安碩MSCI台灣ETF",
    "tick": [],
    "focus": "总市场",
    "fundSize": "109.15",
    "returns": {
      "total_return": "+170.61%",
      "10y": "+269.75%",
      "5y": "+64.33%",
      "3y": "+121.32%",
      "1y": "+81.17%"
    },
    "betas": {
      "beta_5y": "1.14",
      "beta_3y": "1.30",
      "beta_1y": "1.57"
    }
  },
  {
    "symbol": "EWW",
    "symbolEn": "iShares MSCI Mexico ETF",
    "symbolZh": "墨西哥投资指数ETF-iShares MSCI",
    "symbolFan": "墨西哥投資指數ETF-iShares MSCI",
    "tick": [],
    "focus": "总市场",
    "fundSize": "18.68",
    "returns": {
      "total_return": "+627.71%",
      "10y": "+49.24%",
      "5y": "+56.64%",
      "3y": "+19.65%",
      "1y": "+24.14%"
    },
    "betas": {
      "beta_5y": "0.79",
      "beta_3y": "0.62",
      "beta_1y": "0.90"
    }
  },
  {
    "symbol": "EWY",
    "symbolEn": "iShares MSCI SOUTH KOREA ETF",
    "symbolZh": "韩国ETF-iShares MSCI",
    "symbolFan": "韓國ETF-iShares MSCI",
    "tick": [],
    "focus": "总市场",
    "fundSize": "227.34",
    "returns": {
      "total_return": "+817.91%",
      "10y": "+241.30%",
      "5y": "+94.16%",
      "3y": "+176.11%",
      "1y": "+153.40%"
    },
    "betas": {
      "beta_5y": "1.46",
      "beta_3y": "1.85",
      "beta_1y": "2.36"
    }
  },
  {
    "symbol": "EWZ",
    "symbolEn": "iShares MSCI BRAZIL ETF",
    "symbolZh": "巴西ETF-iShares",
    "symbolFan": "巴西ETF-iShares",
    "tick": [],
    "focus": "总市场",
    "fundSize": "88.79",
    "returns": {
      "total_return": "+83.63%",
      "10y": "+13.86%",
      "5y": "-14.48%",
      "3y": "+5.21%",
      "1y": "+19.76%"
    },
    "betas": {
      "beta_5y": "0.64",
      "beta_3y": "0.37",
      "beta_1y": "0.79"
    }
  },
  {
    "symbol": "FVD",
    "symbolEn": "First Trust Value Line Dividend Index Fund",
    "symbolZh": "第一信托超值系列红利指数基金",
    "symbolFan": "第一信託超值系列紅利指數基金",
    "tick": [],
    "focus": "高股息率",
    "fundSize": "80.77",
    "returns": {
      "total_return": "+229.27%",
      "10y": "+83.13%",
      "5y": "+23.29%",
      "3y": "+22.85%",
      "1y": "+8.69%"
    },
    "betas": {
      "beta_5y": "0.65",
      "beta_3y": "0.51",
      "beta_1y": "0.32"
    }
  },
  {
    "symbol": "FXI",
    "symbolEn": "iShares CHINA LARGE-CAP ETF",
    "symbolZh": "中国大盘股ETF-iShares",
    "symbolFan": "中國大盤股ETF-iShares",
    "tick": [],
    "focus": "大盘",
    "fundSize": "45.23",
    "returns": {
      "total_return": "+78.27%",
      "10y": "-7.24%",
      "5y": "-29.74%",
      "3y": "+14.95%",
      "1y": "-12.86%"
    },
    "betas": {
      "beta_5y": "0.32",
      "beta_3y": "0.32",
      "beta_1y": "0.94"
    }
  },
  {
    "symbol": "GDX",
    "symbolEn": "VanEck Vectors Gold Miners ETF",
    "symbolZh": "黄金矿业ETF-VanEck",
    "symbolFan": "黃金礦業ETF-VanEck",
    "tick": [],
    "focus": "材料",
    "fundSize": "227.45",
    "returns": {
      "total_return": "+114.76%",
      "10y": "+175.19%",
      "5y": "+128.06%",
      "3y": "+156.33%",
      "1y": "+50.28%"
    },
    "betas": {
      "beta_5y": "0.65",
      "beta_3y": "0.35",
      "beta_1y": "1.86"
    }
  },
  {
    "symbol": "GDXJ",
    "symbolEn": "VanEck Junior Gold Miners ETF",
    "symbolZh": "小型黄金矿业ETF-VanEck",
    "symbolFan": "小型黃金礦業ETF-VanEck",
    "tick": [],
    "focus": "材料",
    "fundSize": "70.38",
    "returns": {
      "total_return": "-1.05%",
      "10y": "+134.85%",
      "5y": "+117.02%",
      "3y": "+183.82%",
      "1y": "+52.39%"
    },
    "betas": {
      "beta_5y": "0.84",
      "beta_3y": "0.49",
      "beta_1y": "2.15"
    }
  },
  {
    "symbol": "GLD",
    "symbolEn": "SPDR Gold Shares ETF",
    "symbolZh": "黄金ETF-SPDR",
    "symbolFan": "黃金ETF-SPDR",
    "tick": [],
    "focus": "黄金",
    "fundSize": "1316.13",
    "returns": {
      "total_return": "+751.07%",
      "10y": "+196.20%",
      "5y": "+125.95%",
      "3y": "+111.59%",
      "1y": "+22.76%"
    },
    "betas": {
      "beta_5y": "0.17",
      "beta_3y": "0.04",
      "beta_1y": "0.67"
    }
  },
  {
    "symbol": "HDV",
    "symbolEn": "iShares Core High Dividend ETF",
    "symbolZh": "iShares安硕核心高股息ETF",
    "symbolFan": "iShares安碩核心高股息ETF",
    "tick": [],
    "focus": "高股息率",
    "fundSize": "136.73",
    "returns": {
      "total_return": "+176.20%",
      "10y": "+70.68%",
      "5y": "+44.19%",
      "3y": "+38.73%",
      "1y": "+17.87%"
    },
    "betas": {
      "beta_5y": "0.55",
      "beta_3y": "0.34",
      "beta_1y": "0.00"
    }
  },
  {
    "symbol": "HYG",
    "symbolEn": "iShares iBoxx $ High Yield Corporate Bond Fund",
    "symbolZh": "债券指数ETF-iShares iBoxx高收益公司债",
    "symbolFan": "債券指數ETF-iShares iBoxx高收益公司債",
    "tick": [],
    "focus": "高股息率",
    "fundSize": "174.86",
    "returns": {
      "total_return": "-23.61%",
      "10y": "-5.46%",
      "5y": "-9.38%",
      "3y": "+6.89%",
      "1y": "-0.73%"
    },
    "betas": {
      "beta_5y": "0.39",
      "beta_3y": "0.27",
      "beta_1y": "0.22"
    }
  },
  {
    "symbol": "IEMG",
    "symbolEn": "iShares Core MSCI Emerging Mkts ETF",
    "symbolZh": "核心MSCI新兴市场ETF-iShares",
    "symbolFan": "核心MSCI新興市場ETF-iShares",
    "tick": [],
    "focus": "总市场",
    "fundSize": "1569.04",
    "returns": {
      "total_return": "+62.18%",
      "10y": "+92.06%",
      "5y": "+20.08%",
      "3y": "+59.86%",
      "1y": "+33.27%"
    },
    "betas": {
      "beta_5y": "0.73",
      "beta_3y": "0.81",
      "beta_1y": "1.29"
    }
  },
  {
    "symbol": "IJH",
    "symbolEn": "iShares S&P Midcap 400 Index Fund",
    "symbolZh": "标普中型股指数ETF-iShares",
    "symbolFan": "標普中型股指數ETF-iShares",
    "tick": [],
    "focus": "中盘",
    "fundSize": "1235.11",
    "returns": {
      "total_return": "+732.72%",
      "10y": "+155.22%",
      "5y": "+39.99%",
      "3y": "+45.05%",
      "1y": "+19.56%"
    },
    "betas": {
      "beta_5y": "1.02",
      "beta_3y": "1.01",
      "beta_1y": "0.80"
    }
  },
  {
    "symbol": "IJR",
    "symbolEn": "iShares Core S&P Small-Cap ETF",
    "symbolZh": "标普小盘股指数ETF-iShares",
    "symbolFan": "標普小盤股指數ETF-iShares",
    "tick": [],
    "focus": "小盘",
    "fundSize": "1108.43",
    "returns": {
      "total_return": "+814.62%",
      "10y": "+152.12%",
      "5y": "+28.50%",
      "3y": "+46.00%",
      "1y": "+29.85%"
    },
    "betas": {
      "beta_5y": "1.02",
      "beta_3y": "1.09",
      "beta_1y": "0.85"
    }
  },
  {
    "symbol": "ITOT",
    "symbolEn": "iShares Trust S & P 1500",
    "symbolZh": "标普全美股市ETF-iShares",
    "symbolFan": "標普全美股市ETF-iShares",
    "tick": [],
    "focus": "总市场",
    "fundSize": "939.99",
    "returns": {
      "total_return": "+550.49%",
      "10y": "+243.85%",
      "5y": "+64.32%",
      "3y": "+67.18%",
      "1y": "+21.30%"
    },
    "betas": {
      "beta_5y": "1.02",
      "beta_3y": "1.04",
      "beta_1y": "1.01"
    }
  },
  {
    "symbol": "IVE",
    "symbolEn": "iShares S&P 500 Value ETF",
    "symbolZh": "标普500价值指数ETF-iShares",
    "symbolFan": "標普500價值指數ETF-iShares",
    "tick": [],
    "focus": "大盘",
    "fundSize": "480.29",
    "returns": {
      "total_return": "+286.18%",
      "10y": "+147.85%",
      "5y": "+54.80%",
      "3y": "+42.50%",
      "1y": "+16.29%"
    },
    "betas": {
      "beta_5y": "0.83",
      "beta_3y": "0.80",
      "beta_1y": "0.66"
    }
  },
  {
    "symbol": "IVV",
    "symbolEn": "iShares Core S&P 500 ETF (USD)",
    "symbolZh": "标普500ETF-iShares",
    "symbolFan": "標普500ETF-iShares",
    "tick": [],
    "focus": "大盘",
    "fundSize": "8854.26",
    "returns": {
      "total_return": "+424.64%",
      "10y": "+255.46%",
      "5y": "+72.63%",
      "3y": "+67.83%",
      "1y": "+20.68%"
    },
    "betas": {
      "beta_5y": "1.01",
      "beta_3y": "1.01",
      "beta_1y": "1.02"
    }
  },
  {
    "symbol": "IVW",
    "symbolEn": "iShares S&P 500 Growth ETF",
    "symbolZh": "标普500成长股指数ETF-iShares",
    "symbolFan": "標普500成長股指數ETF-iShares",
    "tick": [],
    "focus": "大盘",
    "fundSize": "745.25",
    "returns": {
      "total_return": "+568.69%",
      "10y": "+364.45%",
      "5y": "+84.68%",
      "3y": "+92.27%",
      "1y": "+22.70%"
    },
    "betas": {
      "beta_5y": "1.18",
      "beta_3y": "1.21",
      "beta_1y": "1.30"
    }
  },
  {
    "symbol": "IWB",
    "symbolEn": "iShares Russell 1000 ETF",
    "symbolZh": "罗素1000指数ETF-iShares",
    "symbolFan": "羅素1000指數ETF-iShares",
    "tick": [],
    "focus": "大盘",
    "fundSize": "480.98",
    "returns": {
      "total_return": "+442.06%",
      "10y": "+249.72%",
      "5y": "+67.57%",
      "3y": "+67.45%",
      "1y": "+20.46%"
    },
    "betas": {
      "beta_5y": "1.01",
      "beta_3y": "1.02",
      "beta_1y": "1.00"
    }
  },
  {
    "symbol": "IWD",
    "symbolEn": "iShares Russell 1000 Value ETF",
    "symbolZh": "罗素1000价值指数ETF-iShares",
    "symbolFan": "羅素1000價值指數ETF-iShares",
    "tick": [],
    "focus": "大盘",
    "fundSize": "805.26",
    "returns": {
      "total_return": "+344.70%",
      "10y": "+139.34%",
      "5y": "+54.26%",
      "3y": "+55.93%",
      "1y": "+25.95%"
    },
    "betas": {
      "beta_5y": "0.85",
      "beta_3y": "0.82",
      "beta_1y": "0.71"
    }
  },
  {
    "symbol": "IWF",
    "symbolEn": "iShares Russell 1000 Growth ETF",
    "symbolZh": "罗素1000成长指数ETF-iShares",
    "symbolFan": "羅素1000成長指數ETF-iShares",
    "tick": [],
    "focus": "大盘",
    "fundSize": "1269.54",
    "returns": {
      "total_return": "+519.84%",
      "10y": "+382.42%",
      "5y": "+77.19%",
      "3y": "+76.27%",
      "1y": "+15.40%"
    },
    "betas": {
      "beta_5y": "1.17",
      "beta_3y": "1.20",
      "beta_1y": "1.25"
    }
  },
  {
    "symbol": "IWM",
    "symbolEn": "iShares Russell 2000 ETF",
    "symbolZh": "罗素2000ETF-iShares",
    "symbolFan": "羅素2000ETF-iShares",
    "tick": [],
    "focus": "小盘",
    "fundSize": "821.59",
    "returns": {
      "total_return": "+553.57%",
      "10y": "+158.65%",
      "5y": "+28.27%",
      "3y": "+58.18%",
      "1y": "+36.27%"
    },
    "betas": {
      "beta_5y": "1.11",
      "beta_3y": "1.27",
      "beta_1y": "1.06"
    }
  },
  {
    "symbol": "IWN",
    "symbolEn": "iShares Russell 2000 Value ETF",
    "symbolZh": "罗素2000价值股指数ETF-iShares",
    "symbolFan": "羅素2000價值股指數ETF-iShares",
    "tick": [],
    "focus": "小盘",
    "fundSize": "143.73",
    "returns": {
      "total_return": "+548.59%",
      "10y": "+127.47%",
      "5y": "+32.08%",
      "3y": "+55.88%",
      "1y": "+37.00%"
    },
    "betas": {
      "beta_5y": "1.03",
      "beta_3y": "1.10",
      "beta_1y": "0.89"
    }
  },
  {
    "symbol": "IWS",
    "symbolEn": "iShares Russell Mid-Cap Value ETF",
    "symbolZh": "罗素中型价值股指数ETF-iShares",
    "symbolFan": "羅素中型價值股指數ETF-iShares",
    "tick": [],
    "focus": "中盘",
    "fundSize": "156.23",
    "returns": {
      "total_return": "+550.76%",
      "10y": "+123.97%",
      "5y": "+43.21%",
      "3y": "+50.33%",
      "1y": "+23.16%"
    },
    "betas": {
      "beta_5y": "0.96",
      "beta_3y": "0.93",
      "beta_1y": "0.69"
    }
  },
  {
    "symbol": "LQD",
    "symbolEn": "iShares iBoxx $ Investment Grade Corporate Bond ETF",
    "symbolZh": "债券指数ETF-iShares iBoxx投资级公司债",
    "symbolFan": "債券指數ETF-iShares iBoxx投資級公司債",
    "tick": [],
    "focus": "投资等级",
    "fundSize": "347.48",
    "returns": {
      "total_return": "+5.73%",
      "10y": "-11.67%",
      "5y": "-18.94%",
      "3y": "+1.13%",
      "1y": "-0.47%"
    },
    "betas": {
      "beta_5y": "0.43",
      "beta_3y": "0.37",
      "beta_1y": "0.17"
    }
  },
  {
    "symbol": "MDY",
    "symbolEn": "SPDR S&P Midcap 400 ETF",
    "symbolZh": "标普中型股400指数ETF-SPDR",
    "symbolFan": "標普中型股400指數ETF-SPDR",
    "tick": [],
    "focus": "中盘",
    "fundSize": "273.98",
    "returns": {
      "total_return": "+1742.19%",
      "10y": "+155.06%",
      "5y": "+39.84%",
      "3y": "+44.52%",
      "1y": "+20.88%"
    },
    "betas": {
      "beta_5y": "1.01",
      "beta_3y": "1.00",
      "beta_1y": "0.79"
    }
  },
  {
    "symbol": "RSP",
    "symbolEn": "Invesco S&P 500 Eql Wght ETF",
    "symbolZh": "平均加权指数ETF-Rydex S&P",
    "symbolFan": "平均加權指數ETF-Rydex S&P",
    "tick": [],
    "focus": "大盘",
    "fundSize": "952.08",
    "returns": {
      "total_return": "+743.20%",
      "10y": "+167.50%",
      "5y": "+41.32%",
      "3y": "+43.19%",
      "1y": "+16.39%"
    },
    "betas": {
      "beta_5y": "0.92",
      "beta_3y": "0.87",
      "beta_1y": "0.70"
    }
  },
  {
    "symbol": "SCHB",
    "symbolEn": "Schwab US Broad Market ETF",
    "symbolZh": "嘉信美国整体市场ETF",
    "symbolFan": "嘉信美國整體市場ETF",
    "tick": [],
    "focus": "总市场",
    "fundSize": "431.73",
    "returns": {
      "total_return": "+592.88%",
      "10y": "+244.72%",
      "5y": "+64.88%",
      "3y": "+67.35%",
      "1y": "+20.19%"
    },
    "betas": {
      "beta_5y": "1.02",
      "beta_3y": "1.04",
      "beta_1y": "1.02"
    }
  },
  {
    "symbol": "SCHD",
    "symbolEn": "Schwab US Dividend Equity ETF",
    "symbolZh": "美国红利股ETF-Schwab",
    "symbolFan": "美國紅利股ETF-Schwab",
    "tick": [],
    "focus": "高股息率",
    "fundSize": "964.64",
    "returns": {
      "total_return": "+288.68%",
      "10y": "+134.60%",
      "5y": "+27.57%",
      "3y": "+33.06%",
      "1y": "+18.38%"
    },
    "betas": {
      "beta_5y": "0.70",
      "beta_3y": "0.60",
      "beta_1y": "0.38"
    }
  },
  {
    "symbol": "SCHF",
    "symbolEn": "Schwab International Equity ETF",
    "symbolZh": "嘉信国际股票ETF",
    "symbolFan": "嘉信國際股票ETF",
    "tick": [],
    "focus": "总市场",
    "fundSize": "658.91",
    "returns": {
      "total_return": "+126.93%",
      "10y": "+102.36%",
      "5y": "+38.88%",
      "3y": "+53.98%",
      "1y": "+24.13%"
    },
    "betas": {
      "beta_5y": "0.82",
      "beta_3y": "0.73",
      "beta_1y": "1.06"
    }
  },
  {
    "symbol": "SCHG",
    "symbolEn": "Schwab US Large-Cap Growth ETF",
    "symbolZh": "嘉信美国大盘股成长型ETF",
    "symbolFan": "嘉信美國大盤股成長型ETF",
    "tick": [],
    "focus": "大盘",
    "fundSize": "595.31",
    "returns": {
      "total_return": "+973.80%",
      "10y": "+420.62%",
      "5y": "+85.47%",
      "3y": "+82.28%",
      "1y": "+16.65%"
    },
    "betas": {
      "beta_5y": "1.20",
      "beta_3y": "1.22",
      "beta_1y": "1.29"
    }
  },
  {
    "symbol": "SCHX",
    "symbolEn": "Schwab US Large-Cap ETF",
    "symbolZh": "嘉信理财美国大盘股ETF",
    "symbolFan": "嘉信理財美國大盤股ETF",
    "tick": [],
    "focus": "大盘",
    "fundSize": "716.07",
    "returns": {
      "total_return": "+625.33%",
      "10y": "+254.36%",
      "5y": "+68.19%",
      "3y": "+68.18%",
      "1y": "+19.27%"
    },
    "betas": {
      "beta_5y": "1.01",
      "beta_3y": "1.02",
      "beta_1y": "1.02"
    }
  },
  {
    "symbol": "SDY",
    "symbolEn": "SPDR S&P Dividend ETF",
    "symbolZh": "股息指数ETF-SPDR S&P",
    "symbolFan": "股息指數ETF-SPDR S&P",
    "tick": [],
    "focus": "高股息率",
    "fundSize": "215.16",
    "returns": {
      "total_return": "+186.90%",
      "10y": "+85.48%",
      "5y": "+26.41%",
      "3y": "+26.52%",
      "1y": "+12.19%"
    },
    "betas": {
      "beta_5y": "0.71",
      "beta_3y": "0.60",
      "beta_1y": "0.35"
    }
  },
  {
    "symbol": "SPDW",
    "symbolEn": "SPDR Portfolio Developed World ex-US ETF",
    "symbolZh": "SPDR投资组合发达世界(美国除外)ETF",
    "symbolFan": "SPDR投資組合發達世界(美國除外)ETF",
    "tick": [],
    "focus": "总市场",
    "fundSize": "400.43",
    "returns": {
      "total_return": "+53.35%",
      "10y": "+100.20%",
      "5y": "+35.47%",
      "3y": "+53.82%",
      "1y": "+23.45%"
    },
    "betas": {
      "beta_5y": "0.84",
      "beta_3y": "0.73",
      "beta_1y": "1.03"
    }
  },
  {
    "symbol": "SPY",
    "symbolEn": "SPDR S&P 500 ETF Trust",
    "symbolZh": "标普500ETF-SPDR",
    "symbolFan": "標普500ETF-SPDR",
    "tick": [],
    "focus": "大盘",
    "fundSize": "7821.08",
    "returns": {
      "total_return": "+1593.88%",
      "10y": "+255.74%",
      "5y": "+72.53%",
      "3y": "+67.93%",
      "1y": "+19.65%"
    },
    "betas": {
      "beta_5y": "1.01",
      "beta_3y": "1.01",
      "beta_1y": "1.01"
    }
  },
  {
    "symbol": "SPYG",
    "symbolEn": "SPDR Portfolio S&P 500 Growth ETF",
    "symbolZh": "SPDR Portfolio S&P 500 Growth ETF",
    "symbolFan": "SPDR Portfolio S&P 500 Growth ETF",
    "tick": [],
    "focus": "大盘",
    "fundSize": "523.73",
    "returns": {
      "total_return": "+381.75%",
      "10y": "+364.57%",
      "5y": "+84.48%",
      "3y": "+92.29%",
      "1y": "+22.72%"
    },
    "betas": {
      "beta_5y": "1.18",
      "beta_3y": "1.21",
      "beta_1y": "1.31"
    }
  },
  {
    "symbol": "SPYV",
    "symbolEn": "SPDR Portfolio S&P 500 Value ETF",
    "symbolZh": "SPDR Portfolio S&P 500 Value ETF",
    "symbolFan": "SPDR Portfolio S&P 500 Value ETF",
    "tick": [],
    "focus": "大盘",
    "fundSize": "354.33",
    "returns": {
      "total_return": "+274.11%",
      "10y": "+145.72%",
      "5y": "+54.60%",
      "3y": "+42.40%",
      "1y": "+16.19%"
    },
    "betas": {
      "beta_5y": "0.83",
      "beta_3y": "0.80",
      "beta_1y": "0.68"
    }
  },
  {
    "symbol": "TIP",
    "symbolEn": "iShares TIPS Bond ETF",
    "symbolZh": "通胀债券指数ETF-iShares",
    "symbolFan": "通脹債券指數ETF-iShares",
    "tick": [],
    "focus": "投资等级",
    "fundSize": "145.09",
    "returns": {
      "total_return": "+6.73%",
      "10y": "-7.41%",
      "5y": "-15.01%",
      "3y": "+1.14%",
      "1y": "-0.97%"
    },
    "betas": {
      "beta_5y": "0.28",
      "beta_3y": "0.16",
      "beta_1y": "0.08"
    }
  },
  {
    "symbol": "UNG",
    "symbolEn": "United States Natural Gas Fund ETF",
    "symbolZh": "美国天然气ETF",
    "symbolFan": "美國天然氣ETF",
    "tick": [],
    "focus": "天然气",
    "fundSize": "4.11",
    "returns": {
      "total_return": "-99.82%",
      "10y": "-91.55%",
      "5y": "-77.42%",
      "3y": "-60.23%",
      "1y": "-24.51%"
    },
    "betas": {
      "beta_5y": "0.06",
      "beta_3y": "-0.52",
      "beta_1y": "-0.32"
    }
  },
  {
    "symbol": "URA",
    "symbolEn": "Global X Uranium ETF",
    "symbolZh": "铀价ETF-Global X",
    "symbolFan": "鈾價ETF-Global X",
    "tick": [],
    "focus": "主题",
    "fundSize": "60.36",
    "returns": {
      "total_return": "-58.21%",
      "10y": "+205.51%",
      "5y": "+100.70%",
      "3y": "+98.44%",
      "1y": "+14.18%"
    },
    "betas": {
      "beta_5y": "1.12",
      "beta_3y": "1.22",
      "beta_1y": "2.04"
    }
  },
  {
    "symbol": "USO",
    "symbolEn": "United States Oil Fund LP ETF",
    "symbolZh": "美国原油ETF",
    "symbolFan": "美國原油ETF",
    "tick": [],
    "focus": "原油",
    "fundSize": "20.01",
    "returns": {
      "total_return": "-80.96%",
      "10y": "+12.83%",
      "5y": "+105.90%",
      "3y": "+66.02%",
      "1y": "+39.91%"
    },
    "betas": {
      "beta_5y": "-0.01",
      "beta_3y": "-0.47",
      "beta_1y": "-0.94"
    }
  },
  {
    "symbol": "VB",
    "symbolEn": "Vanguard Small-Cap ETF",
    "symbolZh": "小盘股ETF-Vanguard",
    "symbolFan": "小盤股ETF-Vanguard",
    "tick": [],
    "focus": "小盘",
    "fundSize": "811.50",
    "returns": {
      "total_return": "+514.57%",
      "10y": "+159.52%",
      "5y": "+31.98%",
      "3y": "+50.54%",
      "1y": "+23.88%"
    },
    "betas": {
      "beta_5y": "1.05",
      "beta_3y": "1.11",
      "beta_1y": "0.89"
    }
  },
  {
    "symbol": "VDE",
    "symbolEn": "Vanguard Energy ETF",
    "symbolZh": "能源指数ETF-Vanguard",
    "symbolFan": "能源指數ETF-Vanguard",
    "tick": [],
    "focus": "能源",
    "fundSize": "90.07",
    "returns": {
      "total_return": "+198.67%",
      "10y": "+58.36%",
      "5y": "+94.92%",
      "3y": "+32.91%",
      "1y": "+23.49%"
    },
    "betas": {
      "beta_5y": "0.45",
      "beta_3y": "0.03",
      "beta_1y": "-0.57"
    }
  },
  {
    "symbol": "VEA",
    "symbolEn": "Vanguard FTSE Developed Markets ETF",
    "symbolZh": "富时成熟市场ETF-Vanguard",
    "symbolFan": "富時成熟市場ETF-Vanguard",
    "tick": [],
    "focus": "总市场",
    "fundSize": "2272.49",
    "returns": {
      "total_return": "+46.06%",
      "10y": "+100.08%",
      "5y": "+36.91%",
      "3y": "+52.70%",
      "1y": "+23.95%"
    },
    "betas": {
      "beta_5y": "0.84",
      "beta_3y": "0.75",
      "beta_1y": "1.04"
    }
  },
  {
    "symbol": "VEU",
    "symbolEn": "Vanguard FTSE All World ex US Index Fund Investor Shares",
    "symbolZh": "富时全球(除美国)ETF-Vanguard",
    "symbolFan": "富時全球(除美國)ETF-Vanguard",
    "tick": [],
    "focus": "总市场",
    "fundSize": "663.33",
    "returns": {
      "total_return": "+63.64%",
      "10y": "+93.29%",
      "5y": "+30.88%",
      "3y": "+51.55%",
      "1y": "+23.06%"
    },
    "betas": {
      "beta_5y": "0.77",
      "beta_3y": "0.71",
      "beta_1y": "1.03"
    }
  },
  {
    "symbol": "VGT",
    "symbolEn": "Vanguard Information Technology ETF",
    "symbolZh": "资讯科技ETF-Vanguard",
    "symbolFan": "資訊科技ETF-Vanguard",
    "tick": [],
    "focus": "信息技术",
    "fundSize": "1436.52",
    "returns": {
      "total_return": "+1781.66%",
      "10y": "+757.36%",
      "5y": "+128.60%",
      "3y": "+107.98%",
      "1y": "+37.30%"
    },
    "betas": {
      "beta_5y": "1.34",
      "beta_3y": "1.50",
      "beta_1y": "1.52"
    }
  },
  {
    "symbol": "VHT",
    "symbolEn": "Vanguard Health Care ETF",
    "symbolZh": "健康护理股ETF-Vanguard",
    "symbolFan": "健康護理股ETF-Vanguard",
    "tick": [],
    "focus": "卫生保健",
    "fundSize": "179.15",
    "returns": {
      "total_return": "+518.43%",
      "10y": "+136.47%",
      "5y": "+23.39%",
      "3y": "+26.97%",
      "1y": "+23.37%"
    },
    "betas": {
      "beta_5y": "0.61",
      "beta_3y": "0.52",
      "beta_1y": "0.38"
    }
  },
  {
    "symbol": "VIG",
    "symbolEn": "Vanguard Dividend Appreciation Index Fund",
    "symbolZh": "递增股利ETF-Vanguard",
    "symbolFan": "遞增股利ETF-Vanguard",
    "tick": [],
    "focus": "总市场",
    "fundSize": "1101.28",
    "returns": {
      "total_return": "+379.83%",
      "10y": "+186.53%",
      "5y": "+52.97%",
      "3y": "+47.03%",
      "1y": "+15.30%"
    },
    "betas": {
      "beta_5y": "0.83",
      "beta_3y": "0.76",
      "beta_1y": "0.70"
    }
  },
  {
    "symbol": "VNQ",
    "symbolEn": "Vanguard Real Estate Index Fund",
    "symbolZh": "不动产信托指数ETF-Vanguard",
    "symbolFan": "不動產信託指數ETF-Vanguard",
    "tick": [],
    "focus": "房地产",
    "fundSize": "384.38",
    "returns": {
      "total_return": "+96.63%",
      "10y": "+10.17%",
      "5y": "-4.49%",
      "3y": "+16.23%",
      "1y": "+8.94%"
    },
    "betas": {
      "beta_5y": "1.00",
      "beta_3y": "0.93",
      "beta_1y": "0.55"
    }
  },
  {
    "symbol": "VO",
    "symbolEn": "Vanguard Mid-Cap ETF",
    "symbolZh": "中盘股ETF-Vanguard",
    "symbolFan": "中盤股ETF-Vanguard",
    "tick": [],
    "focus": "中盘",
    "fundSize": "1058.91",
    "returns": {
      "total_return": "+555.89%",
      "10y": "+161.04%",
      "5y": "+34.67%",
      "3y": "+45.89%",
      "1y": "+13.73%"
    },
    "betas": {
      "beta_5y": "1.00",
      "beta_3y": "0.96",
      "beta_1y": "0.70"
    }
  },
  {
    "symbol": "VOE",
    "symbolEn": "Vanguard Mid-Cap Value Index Fund",
    "symbolZh": "中盘价值股ETF-Vanguard",
    "symbolFan": "中盤價值股ETF-Vanguard",
    "tick": [],
    "focus": "中盘",
    "fundSize": "229.98",
    "returns": {
      "total_return": "+295.10%",
      "10y": "+125.08%",
      "5y": "+41.16%",
      "3y": "+43.72%",
      "1y": "+19.53%"
    },
    "betas": {
      "beta_5y": "0.86",
      "beta_3y": "0.78",
      "beta_1y": "0.48"
    }
  },
  {
    "symbol": "VOO",
    "symbolEn": "Vanguard S&P 500 ETF",
    "symbolZh": "标普500ETF-Vanguard",
    "symbolFan": "標普500ETF-Vanguard",
    "tick": [],
    "focus": "大盘",
    "fundSize": "9811.22",
    "returns": {
      "total_return": "+568.14%",
      "10y": "+256.52%",
      "5y": "+72.57%",
      "3y": "+67.99%",
      "1y": "+19.69%"
    },
    "betas": {
      "beta_5y": "1.01",
      "beta_3y": "1.01",
      "beta_1y": "1.01"
    }
  },
  {
    "symbol": "VT",
    "symbolEn": "Vanguard Total World Stock Index Fund",
    "symbolZh": "全球股市指数ETF-Vanguard",
    "symbolFan": "全球股市指數ETF-Vanguard",
    "tick": [],
    "focus": "总市场",
    "fundSize": "773.45",
    "returns": {
      "total_return": "+212.84%",
      "10y": "+168.70%",
      "5y": "+50.05%",
      "3y": "+60.53%",
      "1y": "+20.73%"
    },
    "betas": {
      "beta_5y": "0.93",
      "beta_3y": "0.92",
      "beta_1y": "1.02"
    }
  },
  {
    "symbol": "VTI",
    "symbolEn": "Vanguard Total Stock Market ETF",
    "symbolZh": "整体股市指数ETF-Vanguard",
    "symbolFan": "整體股市指數ETF-Vanguard",
    "tick": [],
    "focus": "总市场",
    "fundSize": "6622.74",
    "returns": {
      "total_return": "+544.12%",
      "10y": "+244.31%",
      "5y": "+64.10%",
      "3y": "+67.10%",
      "1y": "+20.29%"
    },
    "betas": {
      "beta_5y": "1.02",
      "beta_3y": "1.04",
      "beta_1y": "1.00"
    }
  },
  {
    "symbol": "VTV",
    "symbolEn": "Vanguard Value Index Fund",
    "symbolZh": "价值股ETF-Vanguard",
    "symbolFan": "價值股ETF-Vanguard",
    "tick": [],
    "focus": "价值股",
    "fundSize": "1855.73",
    "returns": {
      "total_return": "+343.22%",
      "10y": "+158.21%",
      "5y": "+58.20%",
      "3y": "+53.68%",
      "1y": "+22.30%"
    },
    "betas": {
      "beta_5y": "0.76",
      "beta_3y": "0.71",
      "beta_1y": "0.53"
    }
  },
  {
    "symbol": "VUG",
    "symbolEn": "Vanguard Growth Index Fund",
    "symbolZh": "成长股ETF-Vanguard",
    "symbolFan": "成長股ETF-Vanguard",
    "tick": [],
    "focus": "大盘",
    "fundSize": "2229.53",
    "returns": {
      "total_return": "+936.15%",
      "10y": "+378.86%",
      "5y": "+77.80%",
      "3y": "+81.59%",
      "1y": "+16.74%"
    },
    "betas": {
      "beta_5y": "1.23",
      "beta_3y": "1.27",
      "beta_1y": "1.35"
    }
  },
  {
    "symbol": "VWO",
    "symbolEn": "Vanguard Emerging Markets Stock Index Fund",
    "symbolZh": "富时新兴市场ETF-Vanguard",
    "symbolFan": "富時新興市場ETF-Vanguard",
    "tick": [],
    "focus": "总市场",
    "fundSize": "1212.56",
    "returns": {
      "total_return": "+134.75%",
      "10y": "+66.92%",
      "5y": "+9.64%",
      "3y": "+43.46%",
      "1y": "+18.41%"
    },
    "betas": {
      "beta_5y": "0.62",
      "beta_3y": "0.65",
      "beta_1y": "1.06"
    }
  },
  {
    "symbol": "VXF",
    "symbolEn": "Vanguard Extended Markets Index Fund",
    "symbolZh": "扩展市场ETF-Vanguard",
    "symbolFan": "擴展市場ETF-Vanguard",
    "tick": [],
    "focus": "拓展市场",
    "fundSize": "314.20",
    "returns": {
      "total_return": "+688.46%",
      "10y": "+185.02%",
      "5y": "+27.91%",
      "3y": "+62.81%",
      "1y": "+23.96%"
    },
    "betas": {
      "beta_5y": "1.13",
      "beta_3y": "1.23",
      "beta_1y": "1.01"
    }
  },
  {
    "symbol": "VYM",
    "symbolEn": "Vanguard High Dividend Yield Index Fund",
    "symbolZh": "高股利收益ETF-Vanguard",
    "symbolFan": "高股利收益ETF-Vanguard",
    "tick": [],
    "focus": "高股息率",
    "fundSize": "791.39",
    "returns": {
      "total_return": "+215.74%",
      "10y": "+123.33%",
      "5y": "+51.08%",
      "3y": "+49.63%",
      "1y": "+17.85%"
    },
    "betas": {
      "beta_5y": "0.74",
      "beta_3y": "0.71",
      "beta_1y": "0.60"
    }
  },
  {
    "symbol": "XLB",
    "symbolEn": "Materials Select Sector SPDR",
    "symbolZh": "SPDR原物料类ETF",
    "symbolFan": "SPDR原物料類ETF",
    "tick": [],
    "focus": "材料",
    "fundSize": "81.53",
    "returns": {
      "total_return": "+400.55%",
      "10y": "+124.47%",
      "5y": "+25.52%",
      "3y": "+25.13%",
      "1y": "+13.86%"
    },
    "betas": {
      "beta_5y": "0.93",
      "beta_3y": "0.69",
      "beta_1y": "0.65"
    }
  },
  {
    "symbol": "XLE",
    "symbolEn": "Energy Select Sector SPDR Fund",
    "symbolZh": "能源指数ETF-SPDR",
    "symbolFan": "能源指數ETF-SPDR",
    "tick": [],
    "focus": "能源",
    "fundSize": "351.34",
    "returns": {
      "total_return": "+356.58%",
      "10y": "+56.16%",
      "5y": "+95.02%",
      "3y": "+30.85%",
      "1y": "+22.61%"
    },
    "betas": {
      "beta_5y": "0.44",
      "beta_3y": "0.02",
      "beta_1y": "-0.59"
    }
  },
  {
    "symbol": "XLF",
    "symbolEn": "Financial Select Sector SPDR Fund",
    "symbolZh": "金融行业ETF-SPDR",
    "symbolFan": "金融行業ETF-SPDR",
    "tick": [],
    "focus": "财务指标",
    "fundSize": "526.19",
    "returns": {
      "total_return": "+191.91%",
      "10y": "+200.87%",
      "5y": "+50.41%",
      "3y": "+64.05%",
      "1y": "+5.44%"
    },
    "betas": {
      "beta_5y": "0.87",
      "beta_3y": "0.79",
      "beta_1y": "0.77"
    }
  },
  {
    "symbol": "XLI",
    "symbolEn": "Industrial Select Sector SPDR Fund",
    "symbolZh": "工业指数ETF-SPDR",
    "symbolFan": "工業指數ETF-SPDR",
    "tick": [],
    "focus": "工业",
    "fundSize": "339.35",
    "returns": {
      "total_return": "+692.07%",
      "10y": "+228.23%",
      "5y": "+78.29%",
      "3y": "+71.30%",
      "1y": "+23.70%"
    },
    "betas": {
      "beta_5y": "0.99",
      "beta_3y": "0.92",
      "beta_1y": "0.71"
    }
  },
  {
    "symbol": "XLK",
    "symbolEn": "Technology Select Sector SPDR Fund",
    "symbolZh": "科技行业精选指数ETF-SPDR",
    "symbolFan": "科技行業精選指數ETF-SPDR",
    "tick": [],
    "focus": "信息技术",
    "fundSize": "1206.65",
    "returns": {
      "total_return": "+1014.54%",
      "10y": "+732.21%",
      "5y": "+143.02%",
      "3y": "+108.30%",
      "1y": "+41.64%"
    },
    "betas": {
      "beta_5y": "1.34",
      "beta_3y": "1.49",
      "beta_1y": "1.57"
    }
  },
  {
    "symbol": "XLP",
    "symbolEn": "Consumer Staples Select Sector SPDR",
    "symbolZh": "日常消费品精选行业指数ETF-SPDR",
    "symbolFan": "日常消費品精選行業指數ETF-SPDR",
    "tick": [],
    "focus": "必需消费品",
    "fundSize": "139.54",
    "returns": {
      "total_return": "+228.46%",
      "10y": "+53.83%",
      "5y": "+21.55%",
      "3y": "+13.85%",
      "1y": "+3.31%"
    },
    "betas": {
      "beta_5y": "0.49",
      "beta_3y": "0.43",
      "beta_1y": "0.17"
    }
  },
  {
    "symbol": "XLU",
    "symbolEn": "Utilities Select Sector SPDR Fund",
    "symbolZh": "公用事业精选行业指数ETF-SPDR",
    "symbolFan": "公用事業精選行業指數ETF-SPDR",
    "tick": [],
    "focus": "公用事业",
    "fundSize": "231.66",
    "returns": {
      "total_return": "+202.55%",
      "10y": "+73.46%",
      "5y": "+42.80%",
      "3y": "+38.79%",
      "1y": "+12.61%"
    },
    "betas": {
      "beta_5y": "0.59",
      "beta_3y": "0.42",
      "beta_1y": "-0.08"
    }
  },
  {
    "symbol": "XLV",
    "symbolEn": "Health Care Select Sector SPDR",
    "symbolZh": "医疗保健精选行业指数ETF-SPDR",
    "symbolFan": "醫療保健精選行業指數ETF-SPDR",
    "tick": [],
    "focus": "卫生保健",
    "fundSize": "410.34",
    "returns": {
      "total_return": "+559.90%",
      "10y": "+127.83%",
      "5y": "+28.70%",
      "3y": "+24.47%",
      "1y": "+20.80%"
    },
    "betas": {
      "beta_5y": "0.57",
      "beta_3y": "0.45",
      "beta_1y": "0.30"
    }
  },
  {
    "symbol": "XLY",
    "symbolEn": "Consumer Discretionary Select Sector SPDR Fund",
    "symbolZh": "非必需消费类ETF-SPDR",
    "symbolFan": "非必需消費類ETF-SPDR",
    "tick": [],
    "focus": "非必需消费品",
    "fundSize": "228.90",
    "returns": {
      "total_return": "+825.37%",
      "10y": "+199.77%",
      "5y": "+30.13%",
      "3y": "+36.37%",
      "1y": "+5.99%"
    },
    "betas": {
      "beta_5y": "1.22",
      "beta_3y": "1.15",
      "beta_1y": "1.29"
    }
  },
  {
    "symbol": "AAXJ",
    "symbolEn": "iShares MSCI All Country Asia",
    "symbolZh": "亚洲(除日本)ETF-iShares",
    "symbolFan": "亞洲(除日本)ETF-iShares",
    "tick": [],
    "focus": "总市场",
    "fundSize": "38.62",
    "returns": {
      "total_return": "+127.29%",
      "10y": "+106.41%",
      "5y": "+22.23%",
      "3y": "+68.54%",
      "1y": "+38.29%"
    },
    "betas": {
      "beta_5y": "0.72",
      "beta_3y": "0.86",
      "beta_1y": "1.35"
    }
  },
  {
    "symbol": "ACWI",
    "symbolEn": "iShares MSCI ACWI ETF",
    "symbolZh": "iShares MSCI ACWI ETF",
    "symbolFan": "iShares MSCI ACWI ETF",
    "tick": [],
    "focus": "总市场",
    "fundSize": "329.82",
    "returns": {
      "total_return": "+211.68%",
      "10y": "+177.75%",
      "5y": "+53.45%",
      "3y": "+62.32%",
      "1y": "+21.59%"
    },
    "betas": {
      "beta_5y": "0.92",
      "beta_3y": "0.91",
      "beta_1y": "1.01"
    }
  },
  {
    "symbol": "BND",
    "symbolEn": "Vanguard Total Bond Market Index Fund",
    "symbolZh": "总债券市场ETF-Vanguard",
    "symbolFan": "總債券市場ETF-Vanguard",
    "tick": [],
    "focus": "投资等级",
    "fundSize": "1600.47",
    "returns": {
      "total_return": "-2.61%",
      "10y": "-13.42%",
      "5y": "-14.75%",
      "3y": "+1.07%",
      "1y": "-0.03%"
    },
    "betas": {
      "beta_5y": "0.25",
      "beta_3y": "0.22",
      "beta_1y": "0.08"
    }
  },
  {
    "symbol": "BNDX",
    "symbolEn": "Vanguard Total International Bond ETF",
    "symbolZh": "总体国际债券ETF-Vanguard",
    "symbolFan": "總體國際債券ETF-Vanguard",
    "tick": [],
    "focus": "投资等级",
    "fundSize": "827.43",
    "returns": {
      "total_return": "-4.66%",
      "10y": "-13.92%",
      "5y": "-15.63%",
      "3y": "-0.97%",
      "1y": "-2.17%"
    },
    "betas": {
      "beta_5y": "0.22",
      "beta_3y": "0.18",
      "beta_1y": "0.11"
    }
  },
  {
    "symbol": "DVY",
    "symbolEn": "iShares Select Dividend ETF",
    "symbolZh": "股息指数ETF-iShares Dow Jones",
    "symbolFan": "股息指數ETF-iShares Dow Jones",
    "tick": [],
    "focus": "高股息率",
    "fundSize": "230.01",
    "returns": {
      "total_return": "+213.46%",
      "10y": "+86.58%",
      "5y": "+35.25%",
      "3y": "+39.24%",
      "1y": "+16.66%"
    },
    "betas": {
      "beta_5y": "0.68",
      "beta_3y": "0.61",
      "beta_1y": "0.31"
    }
  },
  {
    "symbol": "EMB",
    "symbolEn": "iShares JP Morgan USD Emerging Markets Bond ETF",
    "symbolZh": "新兴市场美元债ETF-iShares",
    "symbolFan": "新興市場美元債ETF-iShares",
    "tick": [],
    "focus": "广泛信用",
    "fundSize": "144.86",
    "returns": {
      "total_return": "-4.79%",
      "10y": "-16.45%",
      "5y": "-13.93%",
      "3y": "+11.95%",
      "1y": "+4.28%"
    },
    "betas": {
      "beta_5y": "0.51",
      "beta_3y": "0.43",
      "beta_1y": "0.29"
    }
  },
  {
    "symbol": "IBB",
    "symbolEn": "iShares BIOTECHNOLOGY ETF",
    "symbolZh": "生物科技指数ETF-iShares",
    "symbolFan": "生物科技指數ETF-iShares",
    "tick": [],
    "focus": "卫生保健",
    "fundSize": "91.91",
    "returns": {
      "total_return": "+484.76%",
      "10y": "+127.92%",
      "5y": "+18.04%",
      "3y": "+54.47%",
      "1y": "+53.42%"
    },
    "betas": {
      "beta_5y": "0.70",
      "beta_3y": "0.65",
      "beta_1y": "0.69"
    }
  },
  {
    "symbol": "ICLN",
    "symbolEn": "iShares Global Clean Energy ETF",
    "symbolZh": "环球清洁能源ETF-iShares",
    "symbolFan": "環球清潔能源ETF-iShares",
    "tick": [],
    "focus": "主题",
    "fundSize": "28.03",
    "returns": {
      "total_return": "-62.35%",
      "10y": "+123.52%",
      "5y": "-16.30%",
      "3y": "+7.13%",
      "1y": "+47.78%"
    },
    "betas": {
      "beta_5y": "1.09",
      "beta_3y": "1.18",
      "beta_1y": "1.20"
    }
  },
  {
    "symbol": "IEI",
    "symbolEn": "iShares 3-7 Year Treasury Bond ETF",
    "symbolZh": "美国国债3-7年ETF-iShares",
    "symbolFan": "美國國債3-7年ETF-iShares",
    "tick": [],
    "focus": "投资等级",
    "fundSize": "181.83",
    "returns": {
      "total_return": "+17.11%",
      "10y": "-8.12%",
      "5y": "-10.26%",
      "3y": "+2.06%",
      "1y": "-0.85%"
    },
    "betas": {
      "beta_5y": "0.14",
      "beta_3y": "0.11",
      "beta_1y": "0.03"
    }
  },
  {
    "symbol": "INDY",
    "symbolEn": "iShares India 50 ETF",
    "symbolZh": "iShares安硕印度50 ETF",
    "symbolFan": "iShares安碩印度50 ETF",
    "tick": [],
    "focus": "总市场",
    "fundSize": "5.59",
    "returns": {
      "total_return": "+74.75%",
      "10y": "+52.85%",
      "5y": "-6.29%",
      "3y": "-3.05%",
      "1y": "-19.35%"
    },
    "betas": {
      "beta_5y": "0.45",
      "beta_3y": "0.37",
      "beta_1y": "0.64"
    }
  },
  {
    "symbol": "IUSG",
    "symbolEn": "iShares Core S&P US Growth ETF",
    "symbolZh": "核心标普美国增长ETF-iShares",
    "symbolFan": "核心標普美國增長ETF-iShares",
    "tick": [],
    "focus": "总市场",
    "fundSize": "320.63",
    "returns": {
      "total_return": "+475.97%",
      "10y": "+353.39%",
      "5y": "+82.02%",
      "3y": "+89.84%",
      "1y": "+22.97%"
    },
    "betas": {
      "beta_5y": "1.17",
      "beta_3y": "1.20",
      "beta_1y": "1.28"
    }
  },
  {
    "symbol": "IUSV",
    "symbolEn": "iShares Core S&P US Value ETF",
    "symbolZh": "核心美国价值ETF-iShares",
    "symbolFan": "核心美國價值ETF-iShares",
    "tick": [],
    "focus": "总市场",
    "fundSize": "266.91",
    "returns": {
      "total_return": "+367.05%",
      "10y": "+148.34%",
      "5y": "+53.90%",
      "3y": "+42.18%",
      "1y": "+16.28%"
    },
    "betas": {
      "beta_5y": "0.84",
      "beta_3y": "0.81",
      "beta_1y": "0.67"
    }
  },
  {
    "symbol": "MCHI",
    "symbolEn": "iShares MSCI China ETF",
    "symbolZh": "MSCI中国ETF-iShares",
    "symbolFan": "MSCI中國ETF-iShares",
    "tick": [],
    "focus": "总市场",
    "fundSize": "58.99",
    "returns": {
      "total_return": "-1.51%",
      "10y": "+19.65%",
      "5y": "-36.99%",
      "3y": "+11.92%",
      "1y": "-7.30%"
    },
    "betas": {
      "beta_5y": "0.34",
      "beta_3y": "0.39",
      "beta_1y": "1.00"
    }
  },
  {
    "symbol": "PFF",
    "symbolEn": "iShares Preferred and Income Securities ETF",
    "symbolZh": "iShares优先股和收益证券ETF",
    "symbolFan": "iShares優先股和收益證券ETF",
    "tick": [],
    "focus": "广泛信用",
    "fundSize": "131.87",
    "returns": {
      "total_return": "-39.22%",
      "10y": "-23.51%",
      "5y": "-22.32%",
      "3y": "-1.53%",
      "1y": "-1.36%"
    },
    "betas": {
      "beta_5y": "0.53",
      "beta_3y": "0.53",
      "beta_1y": "0.44"
    }
  },
  {
    "symbol": "QQQ",
    "symbolEn": "Invesco QQQ Trust Series 1",
    "symbolZh": "纳指100ETF-Invesco QQQ Trust",
    "symbolFan": "納指100ETF-Invesco QQQ Trust",
    "tick": [],
    "focus": "大盘",
    "fundSize": "4889.08",
    "returns": {
      "total_return": "+1293.84%",
      "10y": "+562.95%",
      "5y": "+99.88%",
      "3y": "+92.65%",
      "1y": "+28.82%"
    },
    "betas": {
      "beta_5y": "1.23",
      "beta_3y": "1.24",
      "beta_1y": "1.35"
    }
  },
  {
    "symbol": "SHV",
    "symbolEn": "iShares Barclays Short Treasury Bond Fund",
    "symbolZh": "美国短期国债ETF-iShares",
    "symbolFan": "美國短期國債ETF-iShares",
    "tick": [],
    "focus": "投资等级",
    "fundSize": "209.94",
    "returns": {
      "total_return": "+1.28%",
      "10y": "-0.27%",
      "5y": "-0.35%",
      "3y": "+0.08%",
      "1y": "-0.03%"
    },
    "betas": {
      "beta_5y": "0.01",
      "beta_3y": "0.00",
      "beta_1y": "0.01"
    }
  },
  {
    "symbol": "SHY",
    "symbolEn": "iShares 1-3 Year Treasury Bond ETF",
    "symbolZh": "美国国债1-3年ETF-iShares",
    "symbolFan": "美國國債1-3年ETF-iShares",
    "tick": [],
    "focus": "投资等级",
    "fundSize": "253.11",
    "returns": {
      "total_return": "+0.81%",
      "10y": "-3.97%",
      "5y": "-4.89%",
      "3y": "+1.44%",
      "1y": "-0.58%"
    },
    "betas": {
      "beta_5y": "0.05",
      "beta_3y": "0.03",
      "beta_1y": "0.01"
    }
  },
  {
    "symbol": "SKYY",
    "symbolEn": "First Trust ISE Cloud Computing Index Fund",
    "symbolZh": "First Trust ISE云计算指数基金",
    "symbolFan": "First Trust ISE雲計算指數基金",
    "tick": [],
    "focus": "信息技术",
    "fundSize": "27.95",
    "returns": {
      "total_return": "+567.62%",
      "10y": "+349.53%",
      "5y": "+27.21%",
      "3y": "+77.86%",
      "1y": "+10.90%"
    },
    "betas": {
      "beta_5y": "1.24",
      "beta_3y": "1.46",
      "beta_1y": "1.24"
    }
  },
  {
    "symbol": "SMH",
    "symbolEn": "VanEck Semiconductor ETF",
    "symbolZh": "半导体指数ETF-VanEck",
    "symbolFan": "半導體指數ETF-VanEck",
    "tick": [],
    "focus": "信息技术",
    "fundSize": "720.43",
    "returns": {
      "total_return": "+1187.59%",
      "10y": "+1991.05%",
      "5y": "+354.82%",
      "3y": "+285.45%",
      "1y": "+109.42%"
    },
    "betas": {
      "beta_5y": "1.71",
      "beta_3y": "1.96",
      "beta_1y": "1.80"
    }
  },
  {
    "symbol": "SOXX",
    "symbolEn": "iShares Semiconductor ETF",
    "symbolZh": "半导体ETF-iShares",
    "symbolFan": "半導體ETF-iShares",
    "tick": [],
    "focus": "信息技术",
    "fundSize": "433.19",
    "returns": {
      "total_return": "+2249.88%",
      "10y": "+1728.22%",
      "5y": "+277.14%",
      "3y": "+232.12%",
      "1y": "+138.86%"
    },
    "betas": {
      "beta_5y": "1.78",
      "beta_3y": "2.14",
      "beta_1y": "1.97"
    }
  },
  {
    "symbol": "TLT",
    "symbolEn": "iShares 20+ Year Treasury Bond ETF",
    "symbolZh": "20+年以上美国国债ETF-iShares",
    "symbolFan": "20+年以上美國國債ETF-iShares",
    "tick": [],
    "focus": "投资等级",
    "fundSize": "417.24",
    "returns": {
      "total_return": "+3.44%",
      "10y": "-39.27%",
      "5y": "-40.71%",
      "3y": "-16.15%",
      "1y": "-1.90%"
    },
    "betas": {
      "beta_5y": "0.51",
      "beta_3y": "0.56",
      "beta_1y": "0.10"
    }
  },
  {
    "symbol": "TQQQ",
    "symbolEn": "ProShares UltraPro QQQ ETF",
    "symbolZh": "三倍做多纳指ETF-ProShares",
    "symbolFan": "三倍做多納指ETF-ProShares",
    "tick": [],
    "focus": "大盘",
    "fundSize": "373.96",
    "returns": {
      "total_return": "+35955.30%",
      "10y": "+3561.78%",
      "5y": "+135.40%",
      "3y": "+256.33%",
      "1y": "+75.71%"
    },
    "betas": {
      "beta_5y": "3.70",
      "beta_3y": "3.98",
      "beta_1y": "4.08"
    }
  },
  {
    "symbol": "VCIT",
    "symbolEn": "Vanguard Intermediate-Term Corporate Bond ETF",
    "symbolZh": "中期公司债券ETF-Vanguard",
    "symbolFan": "中期公司債券ETF-Vanguard",
    "tick": [],
    "focus": "投资等级",
    "fundSize": "669.64",
    "returns": {
      "total_return": "+9.73%",
      "10y": "-8.06%",
      "5y": "-13.24%",
      "3y": "+4.78%",
      "1y": "-0.21%"
    },
    "betas": {
      "beta_5y": "0.33",
      "beta_3y": "0.28",
      "beta_1y": "0.14"
    }
  },
  {
    "symbol": "VCSH",
    "symbolEn": "Vanguard Short-Term Corporate Bond Idx Fd",
    "symbolZh": "短期公司债券ETF-Vanguard",
    "symbolFan": "短期公司債券ETF-Vanguard",
    "tick": [],
    "focus": "投资等级",
    "fundSize": "447.35",
    "returns": {
      "total_return": "+4.82%",
      "10y": "-2.54%",
      "5y": "-4.60%",
      "3y": "+4.54%",
      "1y": "-0.45%"
    },
    "betas": {
      "beta_5y": "0.12",
      "beta_3y": "0.10",
      "beta_1y": "0.06"
    }
  },
  {
    "symbol": "VXUS",
    "symbolEn": "Vanguard Total International Stock Index Fund",
    "symbolZh": "全世界股票ETF-Vanguard",
    "symbolFan": "全世界股票ETF-Vanguard",
    "tick": [],
    "focus": "总市场",
    "fundSize": "1543.34",
    "returns": {
      "total_return": "+69.44%",
      "10y": "+90.39%",
      "5y": "+29.07%",
      "3y": "+50.45%",
      "1y": "+22.42%"
    },
    "betas": {
      "beta_5y": "0.78",
      "beta_3y": "0.71",
      "beta_1y": "1.03"
    }
  }
]
        },
        {
          tabName: "Crypto",
          datas: [
            { symbol: "BTCUSD", tick: [], symbolZh: '比特币', },

          ],
        },
      ],
      tabIndex: 0,
      dataIndex: 0,
      showMore: false,
      innerTableFn: "",
      popupControl: false,
      innerTickIndex: -1,
      targetNavigationIndex: 1,
      isMoible: false,
      lastClickTime: 0,
      newTypeTable: '',
      currentReturnKey: 'total_return',
      showReturnDropdown: false,
      currentBetaKey: 'beta_5y',
      showBetaDropdown: false,
      showBetaTooltip: false,
      returnTextMap: {
        'total_return': '历史总收益率',
        '10y': '过去 10 年',
        '5y': '过去 5 年',
        '3y': '过去 3 年',
        '1y': '过去 1 年'
      },
      betaTextMap: {
        'beta_5y': '过去 5 年 β',
        'beta_3y': '过去 3 年 β',
        'beta_1y': '过去 1 年 β'
      },
      stockLangKey: 'zh-cn', // 初始化语言
      currentStockSortKey: "yearData",
      currentStockSortOrder: "desc",
      
    };
  },
  computed: {
    stockCategoryAllText() {
      return stockCategoryAllTextMap[this.stockLangKey] || stockCategoryAllTextMap.default;
    },
    showData() {
      const rows = this.tableData[this.tabIndex == 1 ? 2 :this.tabIndex == 2 ? 1: this.tabIndex]?.datas.filter(
            (item) => item.tick && item.tick.length
          ) || [];
          if (this.tabIndex != 3) return rows;
          return this.sortStockRows(rows);
    },
    innerTickList() {
      const item = this.showData[this.innerTickIndex];
      return (item && item.tick) || [];
    },
    pageNavigationNumber() {
      return Math.ceil(this.showData.length / 6);
    },
    visiblePages() {
      const total = this.pageNavigationNumber;
      const c = this.targetNavigationIndex;
      if (total <= 5) return Array.from({ length: total }, (_, i) => i + 1);
      if (c <= 3) return [1, 2, 3, '+1', total]; // 0 代表 …
      if (c >= total - 2) return [1, '-1', total - 2, total - 1, total];
      return [1, '-1', c - 1, c, c + 1, '+1', total]; // 7 项
    },
  },
  created() {
    this.tableData.forEach((item, index) => {
      item.datas.forEach((data) => {
        data.rule = this.rulesData(
          data.symbol,
          index == 1 ? 2 : index == 2 ? 1 : index
        );
      });
    });
    this.newTypeTable = ['/service', '/technology'].some(i => location.href.includes(i))
    this.getListData();
    let time = new Date().getMilliseconds();
    this.$http("/ebc/api/getToken/run", {
      date: time,
      CheckSum: md5(time + "YISENCE"),
    }).then((res) => {
      let url = "wss://pricecloud.eappservice.com/ws?token=" + res.data.data;
      this.createWebSocket(url);
    });
    // ;
  },
  mounted() {
    const pageOverlay = document.getElementById("pageOverLay");
    let that = this;
    this.mountPopover()
    !this.newTypeTable && this.setPopover();
    let timer;
    window.addEventListener("resize", () => {
      clearTimeout(timer);
      timer = setTimeout(() => that.checkMobile(), 200);
    });
    that.checkMobile()
    window.ProductVM = this;
    document.dispatchEvent(myEvent);
  },
  methods: {
    

    stockCategoryText(item) {
      const lanTypes = item && item.stockData && item.stockData.lanTypes;
      if (!lanTypes) return "-";
      return lanTypes[this.stockLangKey] || lanTypes.default || "-";
    },

    stockDisplayName(item) {
      if (!item) return "";
      if (this.stockLangKey === "zh-cn") return item.symbolZh || item.symbol;
      if (this.stockLangKey === "zh") return item.symbolFan || item.symbolZh || item.symbol;
      return item.symbolEn || item.symbolZh || item.symbol;
    },

    stockPercentClass(value) {
      const raw = String(value || "").trim();
      if (raw.includes("+")) return "product-green";
      if (raw.includes("-")) return "product-red";
      return "";
    },

    stockPercentNumber(value) {
      if (value == null) return null;
      const number = parseFloat(String(value).replace(/[%\s,]/g, "").replace(/^\+/, ""));
      return Number.isFinite(number) ? number : null;
    },

    sortStockRows(rows) {
      return rows.slice().sort((a, b) => {
        const av = this.stockPercentNumber(
          a && a.stockData && a.stockData.perData ? a.stockData.perData[this.currentStockSortKey] : null
        );
        const bv = this.stockPercentNumber(
          b && b.stockData && b.stockData.perData ? b.stockData.perData[this.currentStockSortKey] : null
        );
        
        if (av == null && bv == null) return 0;
        if (av == null) return 1;
        if (bv == null) return -1;
        
        return this.currentStockSortOrder === "desc" ? bv - av : av - bv;
      });
    },

    selectStockSort(key) {
      if (this.currentStockSortKey === key) {
        this.currentStockSortOrder = this.currentStockSortOrder === "desc" ? "asc" : "desc";
      } else {
        this.currentStockSortKey = key;
        this.currentStockSortOrder = "desc";
      }
      this.targetNavigationIndex = 1;
      this.showMore = false;
    },
    toPctNumber(value) {
      if (value == null) return null;
      const raw = String(value).trim();
      if (!raw) return null;
      const num = parseFloat(raw.replace(/[%\s]/g, '').replace(/^\+/, ''));
      return Number.isFinite(num) ? num : null;
    },
    sortEtfByReturn(key) {
      const etfTab = this.tableData.find((t) => t && t.tabName === "ETF CFDs");
      if (!etfTab || !Array.isArray(etfTab.datas)) return;

      etfTab.datas.sort((a, b) => {
        const av = this.toPctNumber(a && a.returns ? a.returns[key] : null);
        const bv = this.toPctNumber(b && b.returns ? b.returns[key] : null);
        if (av == null && bv == null) return 0;
        if (av == null) return 1;
        if (bv == null) return -1;
        return bv - av;
      });
    },
    selectReturn(key) {
      this.currentReturnKey = key;
      this.sortEtfByReturn(key);
      this.showReturnDropdown = false;
    },
    selectBeta(key) {
      this.currentBetaKey = key;
      this.showBetaDropdown = false;
    },
    initETFTable() {
      this.tableData.forEach(tab => {
        if (tab.tabName === "ETF CFDs") {
          tab.datas.forEach(item => {
            item.fundSize = item.fundSize.replace('亿美元', '');
          });
        }
      });


      // 2. 提取文本的核心函数
      const extractI18nText = () => {
        // 提取收益率文本 (第6列 1-5项)
        const returnItems = document.querySelectorAll('.product-table-th.etf-layout .product-table-td:nth-child(6) .etf-dropdown-item');
        if (returnItems && returnItems.length >= 5) {
          this.returnTextMap['total_return'] = returnItems[0].innerHTML.trim();
          this.returnTextMap['10y'] = returnItems[1].innerHTML.trim();
          this.returnTextMap['5y'] = returnItems[2].innerHTML.trim();
          this.returnTextMap['3y'] = returnItems[3].innerHTML.trim();
          this.returnTextMap['1y'] = returnItems[4].innerHTML.trim();
        }

        // 提取 Beta 文本 
        // 【注意】根据你前面发我的 HTML 结构，Beta 列实际上是第 7 列 (nth-child(7))。
        // 如果你确实改为了第 3 列，请将下面的 nth-child(7) 改为 nth-child(3)
        const betaItems = document.querySelectorAll('.product-table-th.etf-layout .product-table-td:nth-child(7) .etf-dropdown-item');
        if (betaItems && betaItems.length >= 3) {
          this.betaTextMap['beta_5y'] = betaItems[0].innerHTML.trim();
          this.betaTextMap['beta_3y'] = betaItems[1].innerHTML.trim();
          this.betaTextMap['beta_1y'] = betaItems[2].innerHTML.trim();
        }
      };
      this.sortEtfByReturn(this.currentReturnKey);
    },
    mountPopover() {
      const div = document.createElement("div");
      div.className = "popover body-14_regular ";
      div.id = "p1";
      div.innerHTML =
        "订单中的流动性报价层级，展现了市场中最优订单数量，其中第一层是头层报价，提供真正机构原始点差。";

      // 插到 body
      document.body.appendChild(div);
    },
    rulesData(symbol, tabIndex) {
      console.log()
      if (tabIndex == 0) {
        return "500:1";
      } else if (tabIndex == 1) {
        const normalRules = {
          XAUUSD: "500:1",
          XAGUSD: "500:1",
          XBRUSD: "100:1",
          XTIUSD: "50:1",
          XNGUSD: "100:1",
        };
        return normalRules[symbol];
      } else if (tabIndex == 2) {
        return "100:1";
      } else if (tabIndex == 5) {
        return "200:1 <span> *</span>";
      } else {
        return "5:1";
      }
    },
    syncFakeScroll(wrapperSel, scrollSel) {
      const wrap = document.querySelector(wrapperSel);
      const scroll = wrap.querySelector(scrollSel || ".product-box");
      const track = wrap.querySelector(".fake-scrollbar");
      const thumb = wrap.querySelector(".fake-thumb");
      function sync() {
        const w = scroll.clientWidth;
        const sw = scroll.scrollWidth;
        const l = scroll.scrollLeft;
        const maxL = sw - w;
        if (maxL <= 0) {
          thumb.style.width = "0px";
          track.style.display = "none";
          wrap.classList.add("noScroll");
          return;
        }

        const thumbW = (w / sw) * track.clientWidth;
        thumb.style.width = thumbW + "px";
        const maxMove = track.clientWidth - thumbW;
        if (l <= 0) {
          wrap.classList.add("noScroll");
        } else {
          wrap.classList.remove("noScroll");
        }
        thumb.style.transform = `translateX(${(l / maxL) * maxMove}px)`;
      }

      scroll.addEventListener("scroll", sync, { passive: true });
      scroll.addEventListener("resize", sync);
      sync();
      return sync;
    },
    lock() {
      if (this.newTypeTable && !this.isMoible) return
      const pageOverlay = document.getElementById("pageOverLay");

      document.documentElement.classList.add("no-scroll");
      pageOverlay.style.display = "block";
      setTimeout(() => {
        pageOverlay.style.opacity = 1;
      }, 100);
    },
    unlock() {
      const pageOverlay = document.getElementById("pageOverLay");

      pageOverlay.style.opacity = 0;
      setTimeout(() => {
        pageOverlay.style.display = "none";
        document.documentElement.classList.remove("no-scroll");
      }, 700);
    },
    getImage(name) {
      try {
        return require(`@/assets/image/productLogo/${name}.png`);
      } catch (e) {
      }
    },
    showFormPopup(data) {
      if ((Date.now() - this.lastClickTime) < 500) return;
      this.lastClickTime = Date.now();
      if (this.newTypeTable && this.innerTickIndex === data) {
        this.innerTickIndex = -1
      } else {
        this.innerTickIndex = data;
      }
      this.popupControl = true;
      this.lock();
      setTimeout(() => {
        this.innerTableFn && this.innerTableFn();
        this.newTypeTable && this.innerTickIndex != -1 && this.setPopover()

      });
    },
    closePopup() {
      this.popupControl = false;
      this.unlock();
    },
    setPopover() {
      const po = document.getElementById("p1");
      const popover = document.querySelector('[data-popover="p1"]');
      // console.log(popover)
      let ifShow = false;
      function place() {
        const r = popover.getBoundingClientRect();
        if (window.matchMedia("(max-width:996px)").matches) {
          po.style.left = r.left + 18 + "px";
          po.style.top = r.bottom - po.offsetHeight / 2 - 20 + "px";
          return;
        }

        po.style.left = r.left - 20 + "px";
        po.style.top = r.bottom - 5 + "px";
      }
      function show() {
        if (ifShow) return;
        ifShow = true;
        place();
        po.classList.add("show");
      }
      function hide() {
        if (!ifShow) return;
        ifShow = false;
        po.classList.remove("show");
      }
      if (window.matchMedia("(max-width:996px)").matches) {
        popover.addEventListener("click", (e) => {
          e.stopPropagation();
          show();
        });
        document.addEventListener("click", () => {
          if (ifShow) hide();
        });
        return;
      }
      popover.addEventListener("mouseenter", show);
      popover.addEventListener("mouseleave", hide);
      po.addEventListener("mouseenter", show);
      po.addEventListener("mouseleave", hide);
    },
    setTargetNavigationIndex(index) {
      if (index === '+1') {
        this.targetNavigationIndex += 1
      } else if (index === '-1') {
        this.targetNavigationIndex -= 1
      } else {
        this.targetNavigationIndex = index
      }
    },
    checkMobile() {
      const mobile = window.innerWidth < 996;
      if (mobile !== this.isMobile) {
        this.isMoible = mobile;
      }
    },

    changeInnerTable(index) {
      if (this.dataIndex == index) {
        this.dataIndex = -1;
      } else {
        this.dataIndex = index;
      }
    },
    changeHandle(index) {
      this.dataIndex = 0;
      this.innerTickIndex = -1;
      this.tabIndex = index;
      this.targetNavigationIndex = 1;
      this.showMore = false;
      index == 4 && (this.initETFTable())
    },
    // 传入ask,bid,返回点差Spread
     getSpread (t, e) {
        t=t||0;
        e=e||0;
        const o = /^\+?[1-9][0-9]*$/;
        let d = 0,
          c = 0,
          r = 0;
        if (!o.test(t)) d = t.toString().split(".")[1]?.length || 0;
        if (!o.test(e)) c = e.toString().split(".")[1]?.length || 0;
        const len = Math.max(d, c);
        const base = [1, 10, 100, 1000, 10000, 100000][len] || 100000;
        r = base * t - base * e;
        return r.toFixed(0);
      },
    // 比较大小返回对应类名
    compareValues(value1, value2, className = "") {
      // 尝试将两个值转换为数字
      const num1 = Number(value1);
      const num2 = Number(value2);

      // 检查转换后的值是否都是有效的数字
      if (!isNaN(num1) && !isNaN(num2)) {
        if (num1 >= num2) {
          return "product-green";
        } else if (num1 < num2) {
          return "product-red";
        } else {
          // 两者相等的情况
          return className;
        }
      }

      // 如果转换后不是有效数字，则返回空字符串
      return "";
    },
    updateTick(symbolToUpdate, newTickValue) {
      if (!newTickValue || !newTickValue.length) return
      newTickValue = newTickValue.map((el) => {
        return {
          ...el,
          spread: this.getSpread(el.ask_price, el.bid_price),
        };
      });
      // 遍历tableData中的每个tab
      this.tableData.some((tab) => {
        // 查找datas数组中匹配symbol的项
        const itemIndex = tab.datas.findIndex(
          (item) => item.symbol === symbolToUpdate
        );

        if (itemIndex !== -1) {
          // 如果找到了匹配的项
          // 使用Vue.set确保响应式更新
          // console.log("tab", tab.datas, itemIndex, newTickValue);
          newTickValue = newTickValue.map((tickItem, index) => {
            let t = {
              askClassName: this.compareValues(tickItem.ask_price),
              bidClassName: this.compareValues(tickItem.bid_price),
              ...tickItem,
            };
            tab.datas[itemIndex].tick = Array.isArray(tab.datas[itemIndex].tick) ? tab.datas[itemIndex].tick : [];
            if (tab.datas[itemIndex].tick[index]) {
              t = {
                askClassName: this.compareValues(
                  tickItem.ask_price,
                  tab.datas[itemIndex].tick[index].ask_price,
                  tab.datas[itemIndex].tick[index].askClassName
                ),
                bidClassName: this.compareValues(
                  tickItem.bid_price,
                  tab.datas[itemIndex].tick[index].ask_price,
                  tab.datas[itemIndex].tick[index].bidClassName
                ),
                ...tickItem,
              };
            }

            return t;
          });
          this.$set(tab.datas, itemIndex, {
            ...tab.datas[itemIndex], // 保留原有数据
            tick: newTickValue, // 更新tick值
          });
          return true; // 找到后退出some循环
        }
      });
    },
    createWebSocket(url) {
      let _this = this;
      var ws = new WebSocket(url);

      ws.onopen = function () {
        ws.send("连接成功");
      };
      let f = true;
      ws.onmessage = function (event) {
        try {
          var data = JSON.parse(event.data);
        } catch (e) {
          return false;
        }
        _this.updateTick(data.symbol, data.tick);
      };

      ws.onerror = function (event) { };

      ws.onclose = function () { };
    },
    // 获取历史数据列表
    getListData() {
      fetch("https://www.ebccfd.com/portal/api/getSymbolAll", {
        method: "get",
      })
        .then((response) => {
          // 检查请求是否成功
          if (!response.ok) {
            throw new Error(
              "Network response was not ok " + response.statusText
            );
          }
          // 将 Response 对象转换为 JSON 对象
          return response.json();
        })
        .then((response) => {
          let data = response.rows;
          data.map((item,index) => {
            let t = {
              symbol: item.displaySymbol,
              time: new Date(item.updateTime).getTime(),
              tick: [
                {
                  ask_price: item.ask,
                  ask_size: "",
                  bid_price: item.bid,
                  bid_size: "",
                  spread: this.getSpread(item.ask, item.bid),
                },
              ],
            };
            if(!item.ask || !item.bid) return
            this.updateTick(t.symbol, t.tick);
          });
          let that = this
          setTimeout(() => {
            that.syncFakeScroll('.productModuleContainer');
            if ((this.newTypeTable && this.isMoible) || !this.newTypeTable) {
              that.innerTableFn = that.syncFakeScroll('.innerTableContainer', '.product-table')
            }
            this.newTypeTable && !window.matchMedia('(max-width: 996px)').matches && this.showFormPopup(0)
          })
        })
        .catch((err) => { });
    },
  },
};
</script>

<style lang="scss">
.no-scroll {
  overflow: hidden;
}

.popover {
  --shadow: rgba(0, 0, 0, 0.6);
  --arrow-shadow: rgba(0, 0, 0, 0.5);
}

.popover {
  position: fixed;
  margin-top: 8px;
  padding: 8px 12px;
  color: var(--ebc-text-primary_white);
  background: var(--ebc-neutral-bg_d);
  border-radius: var(--ebc-corner-radius-rc04);
  box-shadow: 0 2px 8px var(--shadow);
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.2s;
  max-width: 500rem;
  z-index: 99999999;
  text-align: left;
  font-size: 14rem;
  line-height: 22rem;
}

.popover.show {
  opacity: 1;
  visibility: visible;
}

/* 阴影三角 + 本体三角 */
.popover::before,
.popover::after {
  content: "";
  position: absolute;
  left: 28px;
  transform: translateX(-50%);
  width: 0;
  height: 0;
  border-left: 6px solid transparent;
  border-right: 6px solid transparent;
  border-bottom: 6px solid var(--ebc-neutral-bg_d);
}

.ar.popover::before,
.ar.popover::after {
  left: unset;
  right: 28px;
}

.popover::before {
  top: -7px;
}

.popover::after {
  top: -6px;
}

.formPopup {
  border-radius: var(--ebc-corner-radius-rc24);
  background: var(--ebc-basecolor-white-100);
  box-shadow: 20px 40px 60px 0 rgba(0, 0, 0, 0.1);
  width: 1000rem;
  /* height: fit-content; */
  padding: 32rem;
  position: fixed;
  z-index: -1;
  left: 50%;
  top: 240rem;
  transform: translate(-50%, 0) scale(0.1);
  opacity: 0;
  transition: bottom 0.3s ease-in-out, opacity 0.3s ease-in-out,
    transform 0.3s ease-in-out;
  transform-origin: center;
}

.formPopup svg {
  cursor: pointer;
}

@media (max-height: 850px) and (min-width: 996px) {
  .formPopup {
    top: 160rem;
  }
}

.formPopup svg {
  position: absolute;
  top: 24rem;
  right: 24rem;
  width: 32rem;
  height: 32rem;
}

.ar .formPopup svg {
  right: unset;
  left: 24rem;
}

.formPopup h3 {
  margin: 16rem 0 32rem;
}

.showFormPopup {
  z-index: 999999;
  opacity: 1;
  transform: translate(-50%, 0%) scale(1);
}

#productModule {
  margin-top: 60rem;
}

#productModule .product-box {
  width: 1200rem;
  margin: 0 auto;
}

@media (min-width: 996px) {
  .newTypeInnerTable {
    padding-inline: 32rem;
  }

  .newTypeTable .product-innertable-tbody {
    height: fit-content !important;
  }

  #productModule .newTypeTable .product-table-tr {
    border-bottom: 0;
  }

  .newTypeTableChooseRow .product-innertable,
  .newTypeTableChooseRow .product-innertable-tr,
  .newTypeTableChooseRow .newTypeInnerTable,
  .newTypeTableChooseRow .product-table-tr {
    background: var(--ebc-neutral-bg_b) !important;
  }

  .newTypeTable .product-table-th .product-table-td:nth-child(2),
  .newTypeTable .product-table-th .product-table-td:nth-child(3),
  .newTypeTable .product-table-tr .product-table-td:nth-child(2),
  .newTypeTable .product-table-tr .product-table-td:nth-child(3) {
    text-align: right !important;
    justify-content: flex-end !important;
  }

  .newTypeTable .product-table-th .product-table-td:nth-child(6),
  .newTypeTable .product-table-tr .product-table-td:nth-child(6) {
    text-align: right !important;
    justify-content: flex-end !important;
    padding-right: 32rem !important;
  }

  .newTypeTable .rotate90 {
    transform: rotate(0deg) !important;
  }

  .newTypeTable .newTypeTableChooseRow .rotate90 {
    transform: rotate(180deg) !important;
  }

  #productModule .product-box .product-table {
    border-top: 1px solid rgba(0, 0, 0, 0.05);
    background: var(--Neutral-BG_A, #FFF);
    overflow: hidden;
  }

  #productModule .product-box .product-table.newTypeTable {
    border: 2px solid rgba(0, 0, 0, 0.12);
    border-radius: var(--ebc-corner-radius-rc16);
    overflow: hidden;
  }

  #productModule .innerTableContainer .product-table {
    border: 0;
    overflow: unset
  }
}

#productModule .iBtn {
  border: 0;
  margin: 20rem auto;
}

#productModule .product-table-th {
  display: flex;
  background-color: #fff;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
}

#productModule .newTypeTable .product-table-th {
  border-bottom: 1px solid rgba(0, 0, 0, 0.12);
}

@media (min-width: 996px) {
  #productModule .newTypeTable .product-table-th {
    background: var(--ebc-neutral-bg_c);
    border-top-left-radius: var(--ebc-corner-radius-rc16);
    border-top-right-radius: var(--ebc-corner-radius-rc16);
  }

  #productModule .product-box {
    width: 1200rem;
    margin-inline: auto;
  }
}

#productModule .product-table-th .product-table-td {
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  flex: 1.5;
  color: var(--ebc-text-primary);
  padding: 27rem 0;
}

#productModule.jp .product-table-tr .product-table-td,
#productModule.jp .product-table-th .product-table-td {
  flex: 2;
}

#productModule .product-table-th .product-table-td:first-child {
  flex: 4;
  justify-content: flex-start;
  padding-left: 32rem;
}

#productModule.ar .product-table-tr .product-table-td:first-child,
#productModule.ar .product-table-th .product-table-td:first-child {
  padding-right: 24rem;
}

#productModule .product-table-th .product-table-td:nth-child(2),
#productModule .product-table-th .product-table-td:nth-child(3),
#productModule .product-table-th .product-table-td:nth-child(6) {
  flex: 2;
}

#productModule .product-table-tr {
  display: flex;
  background: #fff;
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
  cursor: pointer;
}

#productModule .product-table-tr:hover,
#productModule .product-table-tr:hover .product-table-td:first-child {
  background: var(--ebc-neutral-bg_b);
}

#productModule .product-table-tr .product-table-td {
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  flex: 2;
  color: var(--ebc-text-primary);
  line-height: 1em;
  padding: 32rem 0;
}

#productModule .product-table-tr .product-table-td {
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  flex: 1.5;
  color: var(--ebc-text-primary);
  line-height: 1em;
  padding-block: 24rem;
}

#productModule .newTypeTable .product-table-tr .product-table-td {
  padding: 32rem 0;
}

.product-table-td .productPageTable {
  gap: 16rem;
  line-height: 26rem;
}

.product-table-td .productPageTable img {
  width: 40rem;
  height: 40rem;
}

.product-table-td .productPageTable .secondTitle {
  color: var(--ebc-text-secondary);
  margin-top: 2rem;
}

@media (max-width: 996px) {
  .product-table-td .productPageTable {
    gap: 24rem;
    line-height: 48rem;
  }

  .product-table-td .productPageTable img {
    width: 56rem;
    height: 56rem;
  }
}

#productModule .product-table-tr .product-table-td:nth-child(2),
#productModule .product-table-tr .product-table-td:nth-child(3),
#productModule .product-table-th .product-table-td:nth-child(2),
#productModule .product-table-th .product-table-td:nth-child(3) {
  text-align: left;
  justify-content: flex-start;
}

#productModule .product-table-tr .product-table-td:first-child {
  flex: 4;
  justify-content: flex-start;
  padding-left: 32rem;
  text-align: left;
}

#productModule.es .product-table-tr .product-table-td:first-child,
#productModule.es .product-table-th .product-table-td:first-child {
  flex: 3;
}

#productModule.pt .product-table-tr .product-table-td:nth-child(5),
#productModule.pt .product-table-th .product-table-td:nth-child(5),
#productModule.es .product-table-tr .product-table-td:nth-child(5),
#productModule.es .product-table-th .product-table-td:nth-child(5) {
  flex: 2;
}

#productModule .product-table-tr .product-table-td:nth-child(2),
#productModule .product-table-tr .product-table-td:nth-child(3),
#productModule .product-table-tr .product-table-td:nth-child(6) {
  flex: 2;
}

/* #productModule .grow-product-table .product-table-tr .product-table-td {
    width: 23.99%;
  } */

#productModule .rotate90 {
  transform: rotate(-90deg);
  margin-left: 4rem;
}

#productModule .rotate180 {
  transform: rotate(180deg);
}

#productModule .product-innertable {
  background-color: #fff;
}

#productModule .product-innertable-th {
  display: flex;
  height: 64rem;
  color: var(--ebc-text-secondary);
  border-bottom: 1px solid rgba(0, 0, 0, 0.12);
  padding-right: 12rem;
}

#productModule.ar .product-innertable-tbody,
#productModule.ar .product-innertable-tr,
#productModule.ar .product-innertable-th {
  padding-right: 0;
  padding-left: 12rem;
}

#productModule .product-innertable-th .product-innertable-td:first-child {
  justify-content: flex-start;
  flex: 0.6;
}

#productModule .product-innertable-th .product-innertable-td {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  flex: 1;
}

#productModule .product-innertable-th .product-innertable-td .iconfont {
  margin-left: 4rem;
}

#productModule.ar .product-innertable-th .product-innertable-td .iconfont {
  margin-right: 4rem;
  margin-left: unset;
}

/* #productModule
    .grow-product-table
    .product-innertable-th
    .product-innertable-td {
    width: 23.99%;
  } */
#productModule .product-innertable-tbody {
  height: 320rem;
  overflow-y: auto;
  padding-right: 12rem;
}

#productModule .product-innertable-tr {
  display: flex;
  height: 64rem;
  background: #fff;
}

#productModule .product-innertable-tr .product-innertable-td:nth-child(1) {
  flex: 0.6;
  justify-content: flex-start;
}

#productModule .product-innertable-tr .product-innertable-td {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  flex: 1;
  color: var(--ebc-text-primary);
}

/* #productModule
    .grow-product-table
    .product-innertable-tr
    .product-innertable-td {
    width: 23.99%;
  } */

#productModule .product-red {
  color: #cd2626 !important;
}

#productModule .product-green {
  color: #0eb565 !important;
}

@media (max-width: 996px) {

  #productModule .product-table-tr:hover,
  #productModule .product-table-tr:hover .product-table-td:first-child {
    background: #fff;
  }

  #productModule {
    margin-top: 80rem;
  }

  /* #productModule .product-table {
      min-width: fit-content;
    } */
  #productModule .iBtn {
    display: none;
  }

  #productModule .product-box {
    overflow-x: auto;
    max-width: calc(100vw - 32rem);
    padding-bottom: 32rem;
  }

  /* 伪滚动条容器 */
  #productModule .fake-scrollbar {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 90rem;
    height: 4px;
    background: rgba(0, 0, 0, 0.1);
    border-radius: 2px;
    pointer-events: none;
    z-index: 9;
  }

  .innerTableContainer .fake-scrollbar {
    bottom: -55rem !important;
  }

  /* 伪滑块 */
  #productModule .fake-thumb {
    height: 100%;
    background: rgba(0, 0, 0, 0.4);
    border-radius: 2px;
    width: 0;
    /* js 动态算 */
    transition: width 0.2s;
  }

  #productModule .pageNavigation span {
    font-size: 40rem;
    margin-left: 8rem;
  }

  #productModule .pageNavigation span.notAllow {
    pointer-events: none;
    color: var(--ebc-text-tertiary);
  }

  #productModule .pageNavigation span:nth-child(1) {
    margin-right: 8rem;
  }

  #productModule .pageNavigation {
    gap: 8rem;
    padding-top: 48rem;
  }

  #productModule .pageNavigation div {
    padding: 4rem 18rem;
  }

  #productModule .pageNavigation .active {
    font-weight: 500;
    background: var(--ebc-neutral-bg_c);
    border-radius: 50%;
  }

  #productModule .product-table::-webkit-scrollbar,
  #productModule .product-box::-webkit-scrollbar {
    display: none;
  }

  #productModule .product-table-th .product-table-td {
    color: var(--ebc-text-secondary);
    padding: 16rem 0;
    justify-content: flex-end;
  }

  #productModule .product-table-th .product-table-td:nth-child(4),
  #productModule .product-table-th .product-table-td:nth-child(6) {
    justify-content: center;
  }

  #productModule .product-table-tr .product-table-td {
    // white-space: nowrap;
    line-height: 36rem;
    padding: 32rem 0;
  }

  #productModule .product-table-tr,
  #productModule .product-table-th {
    gap: 32rem;
    padding-right: 100rem;
    position: relative;
    width: fit-content;
  }

  #productModule.ar .product-table-tr .product-table-td:first-child,
  #productModule.ar .product-table-th .product-table-td:first-child {
    left: unset;
    right: 0;
  }

  #productModule.ar .product-table-tr,
  #productModule.ar .product-table-th {
    padding-left: 100rem;
    padding-right: 0;
  }

  #productModule .newTypeTable .product-table-tr .product-table-td:first-child,
  #productModule .newTypeTable .product-table-th .product-table-td:first-child {
    flex: 0 0 200rem;
    width: 200rem;
  }

  #productModule .product-table-tr .product-table-td:first-child,
  #productModule .product-table-th .product-table-td:first-child {
    flex-direction: column;
    flex: 0 0 350rem;
    width: 350rem;
    padding-left: 0;
    padding-right: 50rem;
    align-items: flex-start;
    justify-content: center;
    gap: 8rem;
    position: sticky;
    z-index: 99;
    left: 0;
    background: var(--ebc-basecolor-white-100);
  }

  .mn #productModule .product-table-tr .product-table-td:first-child,
  .mn #productModule .product-table-th .product-table-td:first-child {
    flex: 0 0 210rem;
    width: 210rem;
  }


  #productModule .product-table-tr .product-table-td:nth-child(5) {
    justify-content: flex-end;
  }

  .noScroll .product-table-tr .product-table-td:first-child::after,
  .noScroll .product-table-th .product-table-td:first-child::after {
    display: none !important;
  }

  #productModule .product-table-tr .product-table-td:first-child::after,
  #productModule .product-table-th .product-table-td:first-child::after {
    content: "";
    position: absolute;
    top: 0;
    right: -8px;
    /* 控制阴影条水平位置 */
    width: 8px;
    /* 阴影条宽度 */
    height: 100%;
    /* 贯穿整个行高 */
    background: linear-gradient(to right, rgba(0, 0, 0, 0.08), transparent);
    pointer-events: none;
    /* 不影响点击 */
  }

  #productModule.ar .product-table-tr .product-table-td:first-child::after,
  #productModule.ar .product-table-th .product-table-td:first-child::after {
    right: unset;
    left: -8px;
    background: linear-gradient(to left, rgba(0, 0, 0, 0.08), transparent);
  }

  #productModule .product-table-tr .product-table-td:nth-child(2),
  #productModule .product-table-tr .product-table-td:nth-child(3),
  #productModule .product-table-th .product-table-td:nth-child(2),
  #productModule .product-table-th .product-table-td:nth-child(3) {
    flex: 0 0 112rem;
    width: 112rem;
  }

  #productModule.jp .product-table-tr .product-table-td:nth-child(4),
  #productModule.jp .product-table-th .product-table-td:nth-child(4),
  #productModule.kr .product-table-tr .product-table-td:nth-child(4),
  #productModule.kr .product-table-th .product-table-td:nth-child(4) {
    flex: 0 0 120rem;
    width: 120rem;
  }

  #productModule .product-table-tr .product-table-td:nth-child(4),
  #productModule .product-table-th .product-table-td:nth-child(4) {
    flex: 0 0 80rem;
    width: 80rem;
  }

  #productModule .product-table-tr .product-table-td:nth-child(6),
  #productModule .product-table-th .product-table-td:nth-child(6) {
    flex: 0 0 128rem;
    width: 128rem;
  }

  #productModule.es .product-table-tr .product-table-td:nth-child(5),
  #productModule.es .product-table-th .product-table-td:nth-child(5) {
    flex: 0 0 200rem;
    width: 200rem;
  }

  #productModule.es .product-table-tr .product-table-td:nth-child(6),
  #productModule.es .product-table-th .product-table-td:nth-child(6) {
    flex: 0 0 160rem;
    width: 160rem;
  }

  #productModule.jp .product-table-tr .product-table-td:nth-child(6),
  #productModule.jp .product-table-th .product-table-td:nth-child(6) {
    flex: 0 0 160rem;
    width: 160rem;
  }

  #productModule.mn .product-table-tr .product-table-td:nth-child(6),
  #productModule.mn .product-table-th .product-table-td:nth-child(6),
  #productModule.pt .product-table-tr .product-table-td:nth-child(6),
  #productModule.pt .product-table-th .product-table-td:nth-child(6) {
    flex: 0 0 240rem;
    width: 240rem;
  }

  #productModule.jp .product-table-tr .product-table-td:nth-child(5),
  #productModule.jp .product-table-th .product-table-td:nth-child(5) {
    flex: 0 0 150rem;
    width: 150rem;
  }

  #productModule.pt .product-table-tr .product-table-td:nth-child(5),
  #productModule.pt .product-table-th .product-table-td:nth-child(5) {
    flex: 0 0 200rem;
    width: 200rem;
  }

  #productModule .product-table-tr .product-table-td:nth-child(5),
  #productModule .product-table-th .product-table-td:nth-child(5) {
    flex: 0 0 96rem;
    width: 96rem;
    order: 2;
  }

  .formPopup {
    width: 100%;
    bottom: -110%;
    left: 0;
    transform: scale(0);
    top: unset;
    border-radius: 32rem 32rem 0 0;
    padding: 48rem 32rem 96rem;
  }

  .showFormPopup {
    bottom: 0;
    transform: scale(1);
  }

  .formPopup h2 {
    max-width: 75vw;
  }

  .formPopup h3 {
    margin: 16rem 0 48rem;
  }

  .formPopup svg {
    top: 55rem;
    right: 32rem;
    width: 48rem;
    height: 48rem;
  }

  .ar .formPopup svg {
    right: unset;
    left: 32rem;
  }

  .formPopup .product-table {
    max-width: calc(100vw - 64rem);
    overflow: auto;
    padding-bottom: 16rem;
  }

  .formPopup .product-table-row {
    position: relative;
  }

  /* .formPopup .product-table::-webkit-scrollbar{
      display: none;
    } */
  .formPopup .product-table .product-innertable-th,
  .formPopup .product-table .product-innertable-tr {
    padding-right: 24rem;
  }

  .formPopup .product-table .product-innertable-tr,
  .formPopup .product-table .product-innertable-th {
    gap: 48rem;
    /* width:fit-content; */
  }

  .formPopup .product-table .product-innertable-th {
    white-space: nowrap;
  }

  #productModule .product-innertable-th,
  #productModule .product-innertable-tr {
    height: 80rem;
  }

  #productModule .product-innertable-th {
    /* position: sticky; */
    background: var(--ebc-basecolor-white-100);
    /* top:0; */
    /* z-index: 10; */
  }

  #productModule .product-innertable-tbody {
    overflow: visible;
    height: 400rem;
  }

  .formPopup .product-innertable-th {
    width: fit-content;
  }

  .formPopup .product-innertable-td:first-child {
    position: sticky;
    left: 0;
    background: var(--ebc-basecolor-white-100);
    flex: 0 0 114rem !important;
    width: 114rem !important;
  }

  .ar .formPopup .product-innertable-td:first-child {
    left: unset;
    right: 0;
  }

  .formPopup .noScroll .product-innertable-td:first-child::after {
    display: none !important;
  }

  .formPopup .product-innertable-td:first-child::after {
    content: "";
    position: absolute;
    top: 0;
    right: -8px;
    /* 控制阴影条水平位置 */
    width: 8px;
    /* 阴影条宽度 */
    height: 100%;
    /* 贯穿整个行高 */
    background: linear-gradient(to right, rgba(0, 0, 0, 0.08), transparent);
    pointer-events: none;
    /* 不影响点击 */
  }

  .ar .formPopup .product-innertable-td:first-child::after {
    right: unset;
    left: -8px;
    background: linear-gradient(to left, rgba(0, 0, 0, 0.08), transparent);
  }

  .formPopup .product-innertable-td:nth-child(2) {
    flex: 0 0 112rem !important;
    width: 112rem !important;
  }

  .formPopup .product-innertable-td:last-child {
    flex: 0 0 96rem !important;
    width: 96rem !important;
    justify-content: center !important;
  }

  .formPopup .product-innertable-td {
    flex: 0 0 160rem !important;
    width: 160rem;
  }

  /* 把上下三角重置 */
  .popover::before,
  .popover::after {
    left: -10px;
    /* 贴到 popover 左侧 */
    top: 50%;
    transform: translateY(-50%);
    border: 6px solid transparent;
  }

  /* 朝左的三角：右边框着色 */
  .popover::before {
    border-right-color: var(--ebc-neutral-bg_d);
  }

  .popover::after {
    left: -6px;
    border-right-color: var(--ebc-neutral-bg_d);
  }

  .ar.popover::before,
  .ar.popover::after {
    left: unset;
    right: -10px;
    border-left-color: var(--ebc-neutral-bg_d);
    border-right-color: transparent;
  }
}

.hiddenDC .product-table-th .product-table-td:nth-child(4),
.hiddenDC .product-table-tr .product-table-td:nth-child(4) {
  display: none !important;
}

/* ====== ETF 专属布局与组件样式 ====== */
#productModule .etf-layout .product-table-td {
  flex: 1.7 0 0 !important;
  justify-content: center;
}

.etf-layout>div:nth-child(4),
.etf-layout>div:nth-child(4) {
  display: none !important;
}

#productModule .etf-layout .product-table-th:nth-child(2),
#productModule .etf-layout .product-table-th:nth-child(3),
#productModule .etf-layout .product-table-th:nth-child(5),
#productModule .etf-layout .product-table-td:nth-child(2),
#productModule .etf-layout .product-table-td:nth-child(3),
#productModule .etf-layout .product-table-td:nth-child(5) {
  text-align: left !important;
  justify-content: flex-start !important;
}

#productModule .etf-layout .product-table-th:nth-child(6),
#productModule .etf-layout .product-table-td:nth-child(6) {
  justify-content: center !important;
}

#productModule .product-table-th.etf-layout {
  background: #fff;
  border-radius: 0;
}

#productModule .product-table-th.etf-layout .product-table-td {
  color: var(--ebc-text-secondary);
}

#productModule .product-box .product-table.etfLayoutTable {
  border: 0;
  border-top: 1px solid rgba(0, 0, 0, 0.12);
  border-radius: 0;
}

/* 第一列特殊排版: 中英双语上下分行 */
#productModule .etf-layout .product-table-td:first-child {
  flex: 2.4 !important;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  line-height: 1.2;
  padding-inline: 32rem;
  gap: 4px;
}

#pageContainer .tableBtn {
  margin-top: 60rem;
  min-width: 180rem;
  display: flex;
  box-sizing: border-box;
}

@media (max-width: 996px) {
  #pageContainer .tableBtn {
    height: 80rem;
    font-size: 28rem;
    line-height: 0rem;
    margin: 80rem auto 0;
  }
}

/* #productModule .etf-layout .product-table-td:nth-child(2),
#productModule .etf-layout .product-table-td:nth-child(3),
#productModule .etf-layout .product-table-td:nth-child(2),
#productModule .etf-layout .product-table-td:nth-child(3){
  flex: 1!important;
} */
#productModule .etf-symbol-text {
  color: var(--ebc-text-secondary);
}

#productModule .product-table-tr.etf-layout .product-table-td {
  padding-block: 24rem;
}

/* 修复买卖价靠右排版 */

#productModule .etf-layout .product-table-td:nth-child(2),
#productModule .etf-layout .product-table-td:nth-child(3),
#productModule .etf-layout .product-table-td:nth-child(5) {
  text-align: left;
  justify-content: flex-start;
}



/* 2. 调整最后一列下拉菜单的位置：取消居中，改为右对齐，防止菜单超出右侧边界 */
#productModule .etf-layout .product-table-td:last-child .etf-dropdown-menu {
  left: auto;
  right: 0;
  transform: none;
}

/* 3. 同理，调整最后一列 Info 提示气泡的位置：改为右对齐 */
#productModule .etf-layout .product-table-td:last-child .tooltip-box {
  left: auto;
  right: 0;
  transform: none;
}

.dropdown-container {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 4px;
  /* 稍微增加一点箭头的热区，防止太难移上去 */
  margin-left: 2px;
}

/* 下拉菜单外层：用于桥接鼠标悬浮的间隙，防止 mouseleave 断触 */
.etf-dropdown-menu {
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
  padding-top: 8px;
  /* 关键修复：用透明 padding 替代 margin，确保鼠标经过时不会脱离目标 */
  z-index: 100;
  min-width: 130rem;
}

/* 下拉菜单本体（带背景和阴影的部分） */
.etf-dropdown-menu-inner {
  background: #ffffff;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
  border: 1px solid rgba(0, 0, 0, 0.04);
  border-radius: var(--ebc-corner-radius-rc08, 8px);
  padding: 8rem 0;
}

.etf-dropdown-item {
  padding: 8rem 20rem;
  text-align: left;
  cursor: pointer;
  font-size: 14rem;
  color: var(--ebc-text-secondary);
  white-space: nowrap;
  transition: background-color 0.2s;
  font-weight: 400;
  /* 重置掉表头的加粗 */
}


.etf-dropdown-item:hover,
.etf-dropdown-item.active {
  color: var(--ebc-text-primary);
  background: var(--ebc-neutral-bg_b, #f5f5f5);
}

/* ====== β列的 Info 提示框 ====== */
.info-icon {
  position: relative;
  display: inline-flex;
  align-items: center;
  font-size: 14rem;
  color: var(--ebc-text-tertiary, #999);
  margin-left: 2px;
  padding: 4px;
  /* 增加 Hover 热区 */
}

/* 提示气泡，也使用 padding 桥接法 */
.tooltip-box {
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
  background: #ffffff;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
  border: 1px solid rgba(0, 0, 0, 0.04);
  border-radius: var(--ebc-corner-radius-rc08, 8px);
  padding: 12rem 16rem;
  z-index: 101;
  width: 280rem;
  font-size: 14rem;
  color: var(--ebc-text-secondary, #666);
  margin-top: 8px;
  text-align: left;
  line-height: 1.6;
  font-weight: 400;
  /* 重置字体粗细 */
  white-space: normal;
  /* 允许文本自然换行 */
}

#productModule .etf-layout .product-table-td:nth-child(2),
#productModule .etf-layout .product-table-td:nth-child(3) {
  flex: 1 !important;
}

@media (min-width: 996px) {
.stock-layout.product-table-th .product-table-td:nth-child(2), 
 .stock-layout.product-table-th .product-table-td:nth-child(3), 
 .stock-layout.product-table-tr .product-table-td:nth-child(2), 
 .stock-layout.product-table-tr .product-table-td:nth-child(3){
  justify-content: flex-start!important;
  text-align: left!important;
 }
}

@media (max-width: 996px) {
  #productModule .etf-layout .product-table-td:nth-child(5) {
    order: unset;
  }

  #productModule .etf-layout.product-table-tr,
  #productModule .etf-layout.product-table-th {
    width: 250vw !important;
  }



  .tooltip-box,
  .etf-dropdown-item {
    font-size: 24rem;
    padding-block: 16rem;
  }

  .tooltip-box {
    width: 60vw;
  }

  .iconfont.icon-a-tipsicon {
    font-size: 24rem;
  }

  #productModule .product-table-th.etf-layout,
  #productModule .product-box .product-table.etfLayoutTable {
    border: 0;
  }
}
/* stock 专属样式 */
.stock-layout.product-table-tr>div:nth-child(4),
.stock-layout.product-table-th>div:nth-child(4){
  display: flex!important;
}
#productModule .product-box .product-table.stockLayoutTable{
  border: 0;
  border-top: 1px solid rgba(0, 0, 0, 0.12);
  border-radius: 0;
}
#productModule .product-table-th.stock-layout{
  background: #fff;
  border-radius: 0;
}
#productModule .stock-layout .product-table-td{
  box-sizing: border-box;
  flex: 1 0 0!important;
  justify-content: flex-start;
  text-align: left;
}
#productModule .stock-layout .product-table-td:first-child{
  flex: 0 0 400rem!important;
  width: 400rem;
  padding-inline: 32rem;
}
#productModule .stock-layout .product-table-td:nth-child(4){
  flex: 0 0 170rem!important;
  width: 170rem;
}
#productModule .stock-layout .product-table-td:nth-child(5){
  flex: 0 0 180rem!important;
  width: 180rem;
  order: unset;
}
#productModule .stock-layout .product-table-td:nth-child(6){
  flex: 0 0 96rem!important;
  width: 96rem;
  padding-right: 32rem;
}
#productModule .product-table-tr.stock-layout .product-table-td{
  padding-block: 24rem;
}
#productModule .stock-product-cell{
  gap: 16rem;
}
#productModule .stock-product-cell img{
  flex: 0 0 auto;
  width: 40rem;
  height: 40rem;
  border-radius: 50%;
}
#productModule .stock-product-cell .secondTitle{
  margin-top: 2rem;
  color: var(--ebc-text-secondary);
  line-height: 22rem;
}
#productModule .stock-sort-th{
  gap: 8rem;
  user-select: none;
}
#productModule .stock-sort-th .icon-a-down{
  display: inline-block;
  font-size: 16rem;
  color: var(--ebc-text-secondary);
  transition: transform .2s ease;
}
#productModule .stock-sort-th .rotate180{
  transform: rotate(180deg);
}
@media (max-width: 996px) {
#productModule .stock-sort-th .icon-a-down{
  font-size: 28rem;
}
#productModule .product-table-th.stock-layout,
#productModule .product-box .product-table.stockLayoutTable{
border: 0;
}
  #productModule .stock-layout.product-table-tr,
  #productModule .stock-layout.product-table-th{
    width: 220vw!important;
  }
  #productModule .stock-layout .product-table-td:first-child{
    flex: 0 0 360rem!important;
    width: 360rem;
    padding-left: 0;
    padding-right: 50rem;
  }
  #productModule .stock-layout .product-table-td:nth-child(4){
    flex: 0 0 210rem!important;
    width: 210rem;
    justify-content: flex-start;

  }
  #productModule .stock-layout .product-table-td:nth-child(5){
    flex: 0 0 210rem!important;
    width: 210rem;
    justify-content: flex-start;
  }
  #productModule .stock-layout .product-table-td:nth-child(6){
    flex: 0 0 180rem!important;
    width: 180rem;
    padding-right: 0;
    justify-content: center;
  }
  #productModule .stock-product-cell{
    gap: 16rem;
  }
  #productModule .stock-product-cell img{
    width: 56rem;
    height: 56rem;
  }
}
</style>
